import React, { useState, useEffect, useRef } from "react";
import { FaInstagram, FaWhatsapp, FaApple } from "react-icons/fa";
import { IoMailSharp } from "react-icons/io5";
import { RiFacebookCircleLine } from "react-icons/ri";
import { message, Modal, Input, Dropdown } from "antd";
import { useLoading } from "../../Services/loadingService";
import { useParams, useSearchParams } from "react-router-dom";
import { FaLinkedin, FaShare, FaChevronDown, FaChevronUp, FaRegCalendarAlt } from "react-icons/fa";
import defaultimage from "../../Assets/Images/Notfound.png";
import { Theme001, Theme002, Theme003, Theme004 } from "./ThemeLayout";
import { logInstance } from "../../AxiosConfig";
import QRCode from "react-qr-code";
import BookAppointmentModal from "../BookAppointment/BookAppointmentModal";
import EditOtpModal from "./EditOtpModal";
import EditPageWrapper from "./EditPageWrapper";
import EditLogoutButton from "./EditLogoutButton";
// Styles the flip card's .flip-container/.flipper/.front/.back classes (and
// everything ThemeLayout's card faces use) — previously never imported here,
// so the flip card rendered with no styling at all.
import "../../Page/ProfileCard/ProfileCard.css";

const GooglePlayIcon = ({ size = 20 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 27">
    <path d="M0.432 0.607C0.16 0.9 0 1.347 0 1.928v23.146c0 .58.16 1.027.432 1.32L.504 26.459 13.282 13.68v-.314L.504.545l-.072.062z" fill="#00D3FF"/>
    <path d="M17.604 17.968l-4.321-4.322v-.313l4.321-4.322.097.056 5.12 2.91c1.46.83 1.46 2.19 0 3.02l-5.12 2.91-.097.06z" fill="#FFD400"/>
    <path d="M17.7 17.912L13.282 13.5.432 26.393c.48.51 1.277.572 2.166.065L17.7 17.912z" fill="#FF4956"/>
    <path d="M17.7 9.088L2.598.543C1.709.037.912.1.432.607L13.282 13.5 17.7 9.088z" fill="#00EE74"/>
  </svg>
);

const EditPencil = ({ size = 15, color = "#9AA3AF", style = {} }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" style={style}>
    <path d="M12 20h9" />
    <path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z" />
  </svg>
);

const CloseIcon = ({ size = 13, color = "#9AA3AF" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2">
    <path d="M18 6 6 18" />
    <path d="M6 6l12 12" />
  </svg>
);

const TrashIcon = ({ size = 14, color = "#E5484D" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2">
    <path d="M3 6h18" />
    <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2m3 0-1 14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2L4 6h16z" />
  </svg>
);

// Default Services content — shown until the card owner customizes it via
// extendedProfile.services (see Edit mode below).
const DEFAULT_SERVICES = [
  { badge: "NFC Active", title: "Smart Digital Card", desc: "Tap/ QR profile exchange with instant analytics & dynamic branding", cta: "Tap Card" },
  { badge: "AI- Co pilot", title: "Lead AI Agent", desc: "Tap/ QR profile exchange with instant analytics & dynamic branding", cta: "Ask agent" },
  { badge: "Automated", title: "Auto Follow -Up", desc: "Tap/ QR profile exchange with instant analytics & dynamic branding", cta: "Tap Card" },
  { badge: "Voice AI", title: "Voice Transcribe", desc: "Tap/ QR profile exchange with instant analytics & dynamic branding", cta: "Tap Card" },
];

// Default Featured content — a single slide until the owner adds more via
// extendedProfile.features. Each entry: { image, heading (small pill text),
// subheading (bold title) }; `image` empty means "use the decorative gradient".
const DEFAULT_FEATURES = [
  { image: "", heading: "GLOBAL KEYNOTE 2024", subheading: "Enterprise Networking & NFC Ecosystems" },
];

// Default About body — shown as two paragraphs until the owner edits it via
// extendedProfile.about (a single string, paragraphs separated by a blank line).
const DEFAULT_CERTIFICATIONS = ["ISO 27001 Certified", "SOC2 Type 2 Compliant", "24 Enterprise deployments"];

const DEFAULT_TESTIMONIALS = [
  { photo: "", name: "Shivanshu Dubey", role: "Shivanshu Dubey", quote: "Know Connections completely transformed how I network. Sharing my digital card and tracking leads has never been easier", rating: 5 },
  { photo: "", name: "Shivanshu Dubey", role: "Shivanshu Dubey", quote: "Know Connections completely transformed how I network. Sharing my digital card and tracking leads has never been easier", rating: 5 },
];

// Default Contact info rows — `iconType` picks a built-in glyph; a custom
// uploaded `image` (set via the edit form) always takes priority over it.
const DEFAULT_CONTACTS = [
  { iconType: "phone", image: "", label: "Executive Line", value: "999999999" },
  { iconType: "email", image: "", label: "Corporate Email", value: "xyz@gmail.com" },
  { iconType: "website", image: "", label: "Platform Website", value: "know connection.com" },
];

const DEFAULT_STATS = [
  { label: "Years Exp", value: "15+" },
  { label: "Network", value: "500+" },
  { label: "Cards Sent", value: "100+" },
  { label: "Match Rate", value: "98%", green: true },
];

const renderContactIconPaths = (iconType) => {
  if (iconType === "email") {
    return (
      <>
        <rect x="2" y="4" width="20" height="16" rx="2" />
        <path d="M2 7l10 6 10-6" />
      </>
    );
  }
  if (iconType === "website") {
    return (
      <>
        <circle cx="12" cy="12" r="10" />
        <path d="M2 12h20M12 2a15 15 0 0 1 0 20 15 15 0 0 1 0-20z" />
      </>
    );
  }
  if (iconType === "phone") {
    return <path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6 19.8 19.8 0 0 1-3.1-8.6A2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1 1 .4 2 .7 3a2 2 0 0 1-.5 2.1L8 10a16 16 0 0 0 6 6l1.2-1.3a2 2 0 0 1 2.1-.5c1 .3 2 .5 3 .7a2 2 0 0 1 1.7 2z" />;
  }
  // Generic fallback for a custom contact type with no uploaded logo yet.
  return (
    <>
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="M3 9h18M7 13h4" />
    </>
  );
};

// Lazy-loads the Google Maps JS script (with the Places library) once, only
// when the Office Location editor is actually opened — most visitors just
// view the card and never need this. Bumps `.pac-container`'s z-index so the
// Places suggestions dropdown renders above antd's Modal.
let googleMapsScriptPromise = null;
const loadGoogleMapsScript = () => {
  if (window.google?.maps?.places) return Promise.resolve();
  if (googleMapsScriptPromise) return googleMapsScriptPromise;
  googleMapsScriptPromise = new Promise((resolve, reject) => {
    const style = document.createElement("style");
    style.textContent = ".pac-container { z-index: 99999 !important; }";
    document.head.appendChild(style);

    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}&libraries=places`;
    script.async = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error("Failed to load Google Maps"));
    document.head.appendChild(script);
  });
  return googleMapsScriptPromise;
};

const staticMapUrl = (lat, lng, width, height) =>
  `https://maps.googleapis.com/maps/api/staticmap?center=${lat},${lng}&zoom=15&size=${width}x${height}&markers=color:0x1467E0|${lat},${lng}&key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}`;

// Clicking the saved address always offers turn-by-turn directions via
// Google Maps — a plain URL, not a billed API call.
const googleDirectionsUrl = (lat, lng) => `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`;

const getInitials = (name) =>
  (name || "")
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0].toUpperCase())
    .join("") || "?";

const DEFAULT_ABOUT_PARAGRAPHS = [
  "Praveen Reddy is an innovative entrepreneur and technology leader known as the founder of the Know Connections app, a platform designed to bridge communication gaps and enhance professional and social networking. With a strong background in software development and product strategy, he has driven the app's vision to streamline how users build meaningful digital relationships.",
  "Under his leadership, the platform focuses on intuitive user experience, secure data management, and seamless connectivity features tailored to modern networking needs. His entrepreneurial approach combines technical acumen with a sharp focus on scalable digital ecosystems. Praveen continues to guide the company's long-term growth roadmap, positioning it as an emerging tool in the digital community-building space.",
];

const ProductItem = ({ product, cardColor }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isClamped, setIsClamped] = useState(false);
  const descRef = useRef(null);

  useEffect(() => {
    if (descRef.current) {
      setIsClamped(descRef.current.scrollHeight > descRef.current.clientHeight);
    }
  }, []);

  return (
    <div
      style={{
        background: "#fff",
        border: "1px solid #eee",
        borderRadius: 12,
        padding: 12,
      }}
    >
      <div style={{ display: "flex", gap: 12, alignItems: "flex-start" }}>
        {product.image && (
          <img
            src={product.image}
            alt={product.name}
            style={{ width: 64, height: 64, objectFit: "cover", borderRadius: 8, flexShrink: 0 }}
          />
        )}
        <div style={{ flex: 1, minWidth: 0 }}>
          <h4 style={{ fontSize: 14, fontWeight: 600, color: "#1a1a1a", margin: "0 0 2px", textTransform: "capitalize" }}>
            {product.name}
          </h4>
          {product.price !== undefined && product.price !== null && (
            <p style={{ margin: "0 0 4px", fontSize: 13, fontWeight: 700, color: "#0177db" }}>
              {product.currency === "INR" ? "₹" : product.currency === "USD" ? "$" : product.currency === "EUR" ? "€" : product.currency === "GBP" ? "£" : (product.currency + " ")}
              {Number(product.price).toLocaleString("en-IN")}
            </p>
          )}
          <p
            ref={descRef}
            style={{
              fontSize: 12,
              color: "#777",
              margin: "0 0 2px",
              lineHeight: 1.4,
              display: isExpanded ? "block" : "-webkit-box",
              WebkitLineClamp: isExpanded ? "unset" : 2,
              WebkitBoxOrient: "vertical",
              overflow: isExpanded ? "visible" : "hidden",
            }}
          >
            {product.description}
          </p>
          {isClamped && (
            <span
              onClick={() => setIsExpanded((p) => !p)}
              style={{ color: "#2986D6", fontSize: 12, fontWeight: 600, cursor: "pointer" }}
            >
              {isExpanded ? "See less" : "See more"}
            </span>
          )}
        </div>
      </div>
      {(product.checkoutUrl || product.bookingUrl) && (
        <div style={{ marginTop: 10, marginLeft: product.image ? 76 : 0 }}>
          <a
            href={product.checkoutUrl || product.bookingUrl}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: "inline-block",
              padding: "5px 14px",
              background: cardColor || "#2986D6",
              color: "#fff",
              borderRadius: 4,
              fontSize: 11,
              fontWeight: 600,
              textDecoration: "none",
              letterSpacing: 0.5,
            }}
          >
            {product.checkoutUrl ? "BUY NOW" : "BOOK NOW"}
          </a>
        </div>
      )}
    </div>
  );
};

const ProfileCard = () => {
  const [cardsData, setCardsData] = useState({});
  const [products, setProducts] = useState([]);
  const [userImage, setUserImage] = useState("");
  const [isFlipped, setIsFlipped] = useState(false);
  const [cardModalFlipped, setCardModalFlipped] = useState(false);
  const [showDigitalCard, setShowDigitalCard] = useState(false);
  const [visibleCount, setVisibleCount] = useState(3);
  const [qrModal, setQrModal] = useState({ visible: false, value: "" });
  const [bookingVisible, setBookingVisible] = useState(false);
  const [cardModalOpen, setCardModalOpen] = useState(false);

  // ── Share Your Contact — 3-step wizard (Basics / Contacts / Last Stretch)
  const [shareModalOpen, setShareModalOpen] = useState(false);
  const [shareStep, setShareStep] = useState(1);
  const [shareForm, setShareForm] = useState({
    fullName: "", mobile: "", whatsapp: "",
    howWeMet: "", businessCategory: "", notes: "",
  });
  const [submittingShare, setSubmittingShare] = useState(false);

  // ── Edit mode — driven entirely by ?edit=<signed token> in the URL, never
  // by anything else. See src/Middleware/verifyCardEditAccess.js on the
  // backend for what actually authorizes a save; this flag only controls
  // whether edit affordances render at all.
  const [searchParams, setSearchParams] = useSearchParams();
  const editToken = searchParams.get("edit");
  const [isEditMode, setIsEditMode] = useState(false);

  // ── Session-based edit (OTP + shared links)
  const [showEditOtpModal, setShowEditOtpModal] = useState(false);
  const sessionId = searchParams.get("session");
  // Saves are authorized by whichever credential this page was opened with:
  // an ?edit= link token or an OTP ?session= (see verifyCardEditAccess.js).
  const editHeaders = {
    ...(editToken ? { "x-edit-token": editToken } : {}),
    ...(sessionId ? { "x-edit-session": sessionId } : {}),
  };
  const editAuth = { headers: editHeaders };

  const [editIntroModal, setEditIntroModal] = useState(false);
  const [introForm, setIntroForm] = useState({
    yourName: "", designation: "", businessName: "", heading: "",
  });
  const [introPhotoPreview, setIntroPhotoPreview] = useState("");
  const [introPhotoBase64, setIntroPhotoBase64] = useState(null); // holds the uploaded S3 URL once ready, only set if the user actually picks a new photo
  const [introUploadingPhoto, setIntroUploadingPhoto] = useState(false);
  const [savingIntro, setSavingIntro] = useState(false);

  const [serviceModal, setServiceModal] = useState({ open: false, mode: "add", index: null });
  const [serviceForm, setServiceForm] = useState({ title: "", badge: "", desc: "", cta: "" });
  const [savingService, setSavingService] = useState(false);

  const [activeFeatureIndex, setActiveFeatureIndex] = useState(0);
  const [featureModal, setFeatureModal] = useState({ open: false, mode: "add", index: null });
  const [featureForm, setFeatureForm] = useState({ heading: "", subheading: "" });
  const [featurePhotoPreview, setFeaturePhotoPreview] = useState("");
  const [featurePhotoBase64, setFeaturePhotoBase64] = useState(null); // holds the uploaded S3 URL once ready
  const [featureUploadingPhoto, setFeatureUploadingPhoto] = useState(false);
  const [savingFeature, setSavingFeature] = useState(false);

  const [aboutModalOpen, setAboutModalOpen] = useState(false);
  const [aboutForm, setAboutForm] = useState("");
  const [savingAbout, setSavingAbout] = useState(false);

  const [certModal, setCertModal] = useState({ open: false, mode: "add", index: null });
  const [certForm, setCertForm] = useState("");
  const [savingCert, setSavingCert] = useState(false);

  const [testimonialModal, setTestimonialModal] = useState({ open: false, mode: "add", index: null });
  const [testimonialForm, setTestimonialForm] = useState({ name: "", role: "", quote: "", rating: 5 });
  const [testimonialPhotoPreview, setTestimonialPhotoPreview] = useState("");
  const [testimonialPhotoBase64, setTestimonialPhotoBase64] = useState(null); // holds the uploaded S3 URL once ready
  const [testimonialUploadingPhoto, setTestimonialUploadingPhoto] = useState(false);
  const [savingTestimonial, setSavingTestimonial] = useState(false);

  const [contactModal, setContactModal] = useState({ open: false, mode: "add", index: null });
  const [contactForm, setContactForm] = useState({ label: "", value: "" });
  const [contactIconPreview, setContactIconPreview] = useState("");
  const [contactIconBase64, setContactIconBase64] = useState(null); // holds the uploaded S3 URL once ready
  const [contactUploadingLogo, setContactUploadingLogo] = useState(false);
  const [savingContact, setSavingContact] = useState(false);

  const [statsModal, setStatsModal] = useState({ open: false, mode: "add", index: null });
  const [statsForm, setStatsForm] = useState({ label: "", value: "" });
  const [savingStats, setSavingStats] = useState(false);

  const [productModal, setProductModal] = useState({ open: false, mode: "add", index: null });
  const [productForm, setProductForm] = useState({ name: "", price: "", currency: "INR", description: "", type: "product", image: "" });
  const [productPhotoPreview, setProductPhotoPreview] = useState("");
  const [productUploadingPhoto, setProductUploadingPhoto] = useState(false);
  const [savingProduct, setSavingProduct] = useState(false);

  const [videoGalleryModal, setVideoGalleryModal] = useState(false);
  const [videoForm, setVideoForm] = useState({ youtubeUrl: "" });
  const [videos, setVideos] = useState([]);
  const [savingVideo, setSavingVideo] = useState(false);
  const [activeVideoIndex, setActiveVideoIndex] = useState(0);

  const [pdfModalOpen, setPdfModalOpen] = useState(false);
  const [pdfFile, setPdfFile] = useState(null);
  const [pdfUploadingFile, setPdfUploadingFile] = useState(false);
  const [savingPdf, setSavingPdf] = useState(false);

  const [locationModalOpen, setLocationModalOpen] = useState(false);
  const [locationForm, setLocationForm] = useState({ address: "", lat: null, lng: null, placeId: "" });
  const [savingLocation, setSavingLocation] = useState(false);
  const [mapsReady, setMapsReady] = useState(false);
  const locationInputRef = useRef(null);

  const [inquiryModalOpen, setInquiryModalOpen] = useState(false);
  const [inquiryForm, setInquiryForm] = useState({ name: "", phone: "", email: "", message: "" });
  const [submittingInquiry, setSubmittingInquiry] = useState(false);

  // Shared confirm popup for every delete action (replaces window.confirm).
  const [confirmModal, setConfirmModal] = useState({ open: false, message: "", onConfirm: null });
  const askConfirm = (msg, onConfirm) => setConfirmModal({ open: true, message: msg, onConfirm });
  const closeConfirm = () => setConfirmModal({ open: false, message: "", onConfirm: null });
  const handleConfirmYes = () => {
    const fn = confirmModal.onConfirm;
    closeConfirm();
    if (fn) fn();
  };

  const { startLoading, stopLoading } = useLoading();
  const { id } = useParams();
  const openShareModal = () => {
    setShareForm({
      fullName: "", mobile: "", whatsapp: "",
      howWeMet: "", businessCategory: "", notes: "",
    });
    setShareStep(1);
    setShareModalOpen(true);
  };
  const closeShareModal = () => setShareModalOpen(false);

  const goShareBack = () => setShareStep((s) => Math.max(1, s - 1));

  const goShareContinue = () => {
    if (shareStep === 1 && (!shareForm.fullName.trim() || !shareForm.mobile.trim())) {
      message.error("Full name and mobile number are required");
      return;
    }
    setShareStep((s) => Math.min(2, s + 1));
  };

  const submitShare = () => {
    setSubmittingShare(true);
    logInstance
      .post("/profile-form/submit", {
        userId: cardsData.userId,
        name: shareForm.fullName.trim(),
        phnNumber: shareForm.mobile.trim(),
        whatsappNumber: shareForm.whatsapp.trim(),
        howWeMet: shareForm.howWeMet.trim(),
        businessCategory: shareForm.businessCategory.trim(),
        notes: shareForm.notes.trim(),
        type: "share_contact",
      })
      .then(() => {
        message.success("Contact shared successfully!");
        setShareModalOpen(false);
      })
      .catch((error) => {
        console.error("Error submitting form:", error);
        message.error(error?.response?.data?.message || "Failed to share contact. Please try again.");
      })
      .finally(() => setSubmittingShare(false));
  };

  // OTP Modal handlers
  const handleEditOtpSuccess = (sessionData) => {
    setShowEditOtpModal(false);
    // Update URL with session parameter
    setSearchParams({ session: sessionData.sessionId });
  };

  const handleEditOtpCancel = () => {
    setShowEditOtpModal(false);
  };

  const fetchCardsData = () => {
    startLoading();
    logInstance
      .get(`/card/cardId/${id}`)
      .then((response) => {
        console.log("response", response);
        setCardsData(response?.data?.card || {});
        setProducts(response?.data?.products || []);
        setUserImage(response?.data?.userImage || "");
      })
      .catch((error) => {
        console.error("Error fetching Data:", error);
      })
      .finally(() => stopLoading());
  };

  useEffect(() => {
    setVisibleCount(3);
    fetchCardsData();
  }, [id]);

  // Ask the backend whether this token is actually still valid for this
  // exact card — don't just trust "a token is present in the URL." A
  // revoked/expired/wrong-card token must render as plain view, same as no
  // token at all.
  useEffect(() => {
    if (!id || !editToken) {
      setIsEditMode(false);
      return;
    }
    logInstance
      .get(`/card/edit-link/verify`, { params: { cardId: id, token: editToken } })
      .then((res) => setIsEditMode(!!res?.data?.valid))
      .catch(() => setIsEditMode(false));
  }, [id, editToken]);

  // Validate session-based edit access (OTP-based)
  useEffect(() => {
    if (!id || !sessionId) {
      return;
    }
    logInstance
      .get(`/card/validate-edit-session?sessionId=${sessionId}`)
      .then((res) => {
        if (res?.data?.valid && String(res.data.cardId) === String(id)) {
          setIsEditMode(true);
        }
      })
      .catch(() => {
        message.error('Session expired or invalid');
      });
  }, [id, sessionId]);

  const openEditIntro = () => {
    setIntroForm({
      yourName: cardsData.yourName || "",
      designation: cardsData.designation || "Founder & Managing Director",
      businessName: cardsData.businessName || "KnowConnections",
      heading: cardsData?.extendedProfile?.heading || "",
    });
    setIntroPhotoPreview(userImage || cardsData?.extendedProfile?.photo || "");
    setIntroPhotoBase64(null);
    setEditIntroModal(true);
  };

  const handleIntroPhotoChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setIntroPhotoPreview(URL.createObjectURL(file));
    setIntroUploadingPhoto(true);
    uploadCardImageFile(file)
      .then((url) => setIntroPhotoBase64(url))
      .catch(() => message.error("Failed to upload photo"))
      .finally(() => setIntroUploadingPhoto(false));
  };

  const saveIntro = () => {
    if (!introForm.yourName.trim()) {
      message.error("Name can't be empty");
      return;
    }
    setSavingIntro(true);
    const authHeaders = editAuth;
    Promise.all([
      logInstance.patch(
        "/card",
        {
          cardId: id,
          yourName: introForm.yourName.trim(),
          designation: introForm.designation.trim(),
          businessName: introForm.businessName.trim(),
        },
        authHeaders
      ),
      logInstance.patch(
        "/card/extended-profile",
        {
          cardId: id,
          extendedProfile: {
            ...(cardsData.extendedProfile || {}),
            heading: introForm.heading.trim() || "",
            ...(introPhotoBase64 ? { photo: introPhotoBase64 } : {}),
          },
        },
        authHeaders
      ),
    ])
      .then(() => {
        message.success("Intro updated");
        setEditIntroModal(false);
        fetchCardsData();
      })
      .catch((error) => {
        message.error(error?.response?.data?.message || "Failed to update intro");
      })
      .finally(() => setSavingIntro(false));
  };

  const services = cardsData?.extendedProfile?.services || DEFAULT_SERVICES;

  const openAddService = () => {
    setServiceForm({ title: "", badge: "", desc: "", cta: "" });
    setServiceModal({ open: true, mode: "add", index: null });
  };

  const openEditService = (index) => {
    const s = services[index] || {};
    setServiceForm({ title: s.title || "", badge: s.badge || "", desc: s.desc || "", cta: s.cta || "" });
    setServiceModal({ open: true, mode: "edit", index });
  };

  const closeServiceModal = () => setServiceModal((p) => ({ ...p, open: false }));

  const persistServices = (nextServices) => {
    setSavingService(true);
    logInstance
      .patch(
        "/card/extended-profile",
        { cardId: id, extendedProfile: { ...(cardsData.extendedProfile || {}), services: nextServices } },
        editAuth
      )
      .then(() => {
        message.success("Services updated");
        closeServiceModal();
        fetchCardsData();
      })
      .catch((error) => {
        message.error(error?.response?.data?.message || "Failed to update services");
      })
      .finally(() => setSavingService(false));
  };

  const saveService = () => {
    if (!serviceForm.title.trim()) {
      message.error("Service name can't be empty");
      return;
    }
    const entry = {
      title: serviceForm.title.trim(),
      badge: serviceForm.badge.trim(),
      desc: serviceForm.desc.trim(),
      cta: serviceForm.cta.trim() || "Tap Card",
    };
    const next = [...services];
    if (serviceModal.mode === "edit" && serviceModal.index !== null) {
      next[serviceModal.index] = entry;
    } else {
      next.push(entry);
    }
    persistServices(next);
  };

  const deleteService = () => {
    if (serviceModal.index === null) return;
    askConfirm("Delete this service?", () => {
      persistServices(services.filter((_, i) => i !== serviceModal.index));
    });
  };

  const features = cardsData?.extendedProfile?.features || DEFAULT_FEATURES;
  const activeFeature = features[Math.min(activeFeatureIndex, features.length - 1)] || {};

  useEffect(() => {
    if (activeFeatureIndex > features.length - 1) {
      setActiveFeatureIndex(Math.max(0, features.length - 1));
    }
  }, [features.length, activeFeatureIndex]);

  useEffect(() => {
    if (features.length <= 1) return;
    const interval = setInterval(() => {
      setActiveFeatureIndex((prev) => (prev + 1) % features.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [features.length]);

  const openAddFeature = () => {
    setFeatureForm({ heading: "", subheading: "" });
    setFeaturePhotoPreview("");
    setFeaturePhotoBase64(null);
    setFeatureModal({ open: true, mode: "add", index: null });
  };

  const openEditFeature = () => {
    const f = features[activeFeatureIndex] || {};
    setFeatureForm({ heading: f.heading || "", subheading: f.subheading || "" });
    setFeaturePhotoPreview(f.image || "");
    setFeaturePhotoBase64(null);
    setFeatureModal({ open: true, mode: "edit", index: activeFeatureIndex });
  };

  const closeFeatureModal = () => setFeatureModal((p) => ({ ...p, open: false }));

  const handleFeaturePhotoChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setFeaturePhotoPreview(URL.createObjectURL(file));
    setFeatureUploadingPhoto(true);
    uploadCardImageFile(file)
      .then((url) => setFeaturePhotoBase64(url))
      .catch(() => message.error("Failed to upload photo"))
      .finally(() => setFeatureUploadingPhoto(false));
  };

  const persistFeatures = (nextFeatures) => {
    setSavingFeature(true);
    logInstance
      .patch(
        "/card/extended-profile",
        { cardId: id, extendedProfile: { ...(cardsData.extendedProfile || {}), features: nextFeatures } },
        editAuth
      )
      .then(() => {
        message.success("Featured updated");
        closeFeatureModal();
        fetchCardsData();
      })
      .catch((error) => {
        message.error(error?.response?.data?.message || "Failed to update featured content");
      })
      .finally(() => setSavingFeature(false));
  };

  const saveFeature = () => {
    if (!featureForm.heading.trim() && !featureForm.subheading.trim()) {
      message.error("Add a heading or sub heading");
      return;
    }
    const existingImage = featureModal.mode === "edit" ? features[featureModal.index]?.image || "" : "";
    const entry = {
      heading: featureForm.heading.trim(),
      subheading: featureForm.subheading.trim(),
      image: featurePhotoBase64 || existingImage,
    };
    const next = [...features];
    if (featureModal.mode === "edit" && featureModal.index !== null) {
      next[featureModal.index] = entry;
    } else {
      next.push(entry);
      setActiveFeatureIndex(next.length - 1);
    }
    persistFeatures(next);
  };

  const deleteActiveFeature = () => {
    askConfirm("Delete this feature?", () => {
      const next = features.filter((_, i) => i !== activeFeatureIndex);
      setActiveFeatureIndex(0);
      persistFeatures(next);
    });
  };

  const aboutParagraphs = cardsData?.extendedProfile?.about
    ? cardsData.extendedProfile.about.split(/\n{2,}/).filter(Boolean)
    : DEFAULT_ABOUT_PARAGRAPHS;

  const openEditAbout = () => {
    setAboutForm(cardsData?.extendedProfile?.about || DEFAULT_ABOUT_PARAGRAPHS.join("\n\n"));
    setAboutModalOpen(true);
  };

  const saveAbout = () => {
    if (!aboutForm.trim()) {
      message.error("About can't be empty");
      return;
    }
    setSavingAbout(true);
    logInstance
      .patch(
        "/card/extended-profile",
        { cardId: id, extendedProfile: { ...(cardsData.extendedProfile || {}), about: aboutForm.trim() } },
        editAuth
      )
      .then(() => {
        message.success("About updated");
        setAboutModalOpen(false);
        fetchCardsData();
      })
      .catch((error) => {
        message.error(error?.response?.data?.message || "Failed to update about");
      })
      .finally(() => setSavingAbout(false));
  };

  const certifications = cardsData?.extendedProfile?.certifications || DEFAULT_CERTIFICATIONS;

  const openAddCert = () => {
    setCertForm("");
    setCertModal({ open: true, mode: "add", index: null });
  };

  const openEditCert = (index) => {
    setCertForm(certifications[index] || "");
    setCertModal({ open: true, mode: "edit", index });
  };

  const closeCertModal = () => setCertModal((p) => ({ ...p, open: false }));

  const persistCertifications = (nextCertifications) => {
    setSavingCert(true);
    logInstance
      .patch(
        "/card/extended-profile",
        { cardId: id, extendedProfile: { ...(cardsData.extendedProfile || {}), certifications: nextCertifications } },
        editAuth
      )
      .then(() => {
        message.success("Certifications updated");
        closeCertModal();
        fetchCardsData();
      })
      .catch((error) => {
        message.error(error?.response?.data?.message || "Failed to update certifications");
      })
      .finally(() => setSavingCert(false));
  };

  const saveCert = () => {
    if (!certForm.trim()) {
      message.error("Certification name can't be empty");
      return;
    }
    const next = [...certifications];
    if (certModal.mode === "edit" && certModal.index !== null) {
      next[certModal.index] = certForm.trim();
    } else {
      next.push(certForm.trim());
    }
    persistCertifications(next);
  };

  const deleteCert = (index) => {
    askConfirm("Delete this certification?", () => {
      persistCertifications(certifications.filter((_, i) => i !== index));
    });
  };

  const testimonials = cardsData?.extendedProfile?.testimonials || DEFAULT_TESTIMONIALS;

  const openAddTestimonial = () => {
    setTestimonialForm({ name: "", role: "", quote: "", rating: 5 });
    setTestimonialPhotoPreview("");
    setTestimonialPhotoBase64(null);
    setTestimonialModal({ open: true, mode: "add", index: null });
  };

  const openEditTestimonial = (index) => {
    const t = testimonials[index] || {};
    setTestimonialForm({ name: t.name || "", role: t.role || "", quote: t.quote || "", rating: t.rating || 5 });
    setTestimonialPhotoPreview(t.photo || "");
    setTestimonialPhotoBase64(null);
    setTestimonialModal({ open: true, mode: "edit", index });
  };

  const closeTestimonialModal = () => setTestimonialModal((p) => ({ ...p, open: false }));

  const handleTestimonialPhotoChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setTestimonialPhotoPreview(URL.createObjectURL(file));
    setTestimonialUploadingPhoto(true);
    uploadCardImageFile(file)
      .then((url) => setTestimonialPhotoBase64(url))
      .catch(() => message.error("Failed to upload photo"))
      .finally(() => setTestimonialUploadingPhoto(false));
  };

  const persistTestimonials = (nextTestimonials) => {
    setSavingTestimonial(true);
    logInstance
      .patch(
        "/card/extended-profile",
        { cardId: id, extendedProfile: { ...(cardsData.extendedProfile || {}), testimonials: nextTestimonials } },
        editAuth
      )
      .then(() => {
        message.success("Testimonials updated");
        closeTestimonialModal();
        fetchCardsData();
      })
      .catch((error) => {
        message.error(error?.response?.data?.message || "Failed to update testimonials");
      })
      .finally(() => setSavingTestimonial(false));
  };

  const saveTestimonial = () => {
    if (!testimonialForm.name.trim()) {
      message.error("Author name can't be empty");
      return;
    }
    const existingPhoto = testimonialModal.mode === "edit" ? testimonials[testimonialModal.index]?.photo || "" : "";
    const entry = {
      name: testimonialForm.name.trim(),
      role: testimonialForm.role.trim(),
      quote: testimonialForm.quote.trim(),
      rating: testimonialForm.rating,
      photo: testimonialPhotoBase64 || existingPhoto,
    };
    const next = [...testimonials];
    if (testimonialModal.mode === "edit" && testimonialModal.index !== null) {
      next[testimonialModal.index] = entry;
    } else {
      next.push(entry);
    }
    persistTestimonials(next);
  };

  const deleteTestimonial = (index) => {
    askConfirm("Delete this testimonial?", () => {
      persistTestimonials(testimonials.filter((_, i) => i !== index));
    });
  };

  const contacts = cardsData?.extendedProfile?.contacts || DEFAULT_CONTACTS;

  const openAddContact = () => {
    setContactForm({ label: "", value: "" });
    setContactIconPreview("");
    setContactIconBase64(null);
    setContactModal({ open: true, mode: "add", index: null });
  };

  const openEditContact = (index) => {
    const c = contacts[index] || {};
    setContactForm({ label: c.label || "", value: c.value || "" });
    setContactIconPreview(c.image || "");
    setContactIconBase64(null);
    setContactModal({ open: true, mode: "edit", index });
  };

  const closeContactModal = () => setContactModal((p) => ({ ...p, open: false }));

  const handleContactIconChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setContactIconPreview(URL.createObjectURL(file));
    setContactUploadingLogo(true);
    uploadCardImageFile(file)
      .then((url) => setContactIconBase64(url))
      .catch(() => message.error("Failed to upload logo"))
      .finally(() => setContactUploadingLogo(false));
  };

  const persistContacts = (nextContacts) => {
    setSavingContact(true);
    logInstance
      .patch(
        "/card/extended-profile",
        { cardId: id, extendedProfile: { ...(cardsData.extendedProfile || {}), contacts: nextContacts } },
        editAuth
      )
      .then(() => {
        message.success("Contact info updated");
        closeContactModal();
        fetchCardsData();
      })
      .catch((error) => {
        message.error(error?.response?.data?.message || "Failed to update contact info");
      })
      .finally(() => setSavingContact(false));
  };

  const saveContact = () => {
    if (!contactForm.label.trim() || !contactForm.value.trim()) {
      message.error("Label and value are required");
      return;
    }
    const existing = contactModal.mode === "edit" ? contacts[contactModal.index] || {} : {};
    const entry = {
      label: contactForm.label.trim(),
      value: contactForm.value.trim(),
      iconType: existing.iconType || "custom",
      image: contactIconBase64 || existing.image || "",
    };
    const next = [...contacts];
    if (contactModal.mode === "edit" && contactModal.index !== null) {
      next[contactModal.index] = entry;
    } else {
      next.push(entry);
    }
    persistContacts(next);
  };

  const deleteContact = (index) => {
    askConfirm("Delete this contact?", () => {
      persistContacts(contacts.filter((_, i) => i !== index));
    });
  };

  // Convert old object format to new array format for backward compatibility
  const getStatsArray = () => {
    const statsData = cardsData?.extendedProfile?.stats;
    if (Array.isArray(statsData)) return statsData;
    if (statsData && typeof statsData === "object") {
      return [
        { label: "Years Exp", value: statsData.yearsExp || "15+" },
        { label: "Network", value: statsData.network || "500+" },
        { label: "Cards Sent", value: statsData.cardsSent || "100+" },
        { label: "Match Rate", value: statsData.matchRate || "98%", green: true },
      ].filter(s => s.value); // Remove empty stats
    }
    return DEFAULT_STATS;
  };
  const stats = getStatsArray();

  const openAddStat = () => {
    setStatsForm({ label: "", value: "", green: false });
    setStatsModal({ open: true, mode: "add", index: null });
  };

  const openEditStat = (index) => {
    const s = stats[index] || {};
    setStatsForm({ label: s.label || "", value: s.value || "", green: s.green || false });
    setStatsModal({ open: true, mode: "edit", index });
  };

  const closeStatsModal = () => setStatsModal((p) => ({ ...p, open: false }));

  const persistStats = (nextStats) => {
    setSavingStats(true);
    logInstance
      .patch(
        "/card/extended-profile",
        { cardId: id, extendedProfile: { ...(cardsData.extendedProfile || {}), stats: nextStats } },
        editAuth
      )
      .then(() => {
        message.success("Stats updated");
        closeStatsModal();
        fetchCardsData();
      })
      .catch((error) => {
        message.error(error?.response?.data?.message || "Failed to update stats");
      })
      .finally(() => setSavingStats(false));
  };

  const saveStat = () => {
    if (!statsForm.label.trim() || !statsForm.value.trim()) {
      message.error("Label and value are required");
      return;
    }
    const entry = {
      label: statsForm.label.trim(),
      value: statsForm.value.trim(),
      green: statsForm.green || false,
    };
    const next = [...stats];
    if (statsModal.mode === "edit" && statsModal.index !== null) {
      next[statsModal.index] = entry;
    } else {
      next.push(entry);
    }
    persistStats(next);
  };

  const deleteStat = (index) => {
    askConfirm("Delete this stat?", () => {
      persistStats(stats.filter((_, i) => i !== index));
    });
  };

  const openAddProduct = () => {
    setProductForm({ name: "", price: "", currency: "INR", description: "", type: "product", image: "" });
    setProductPhotoPreview("");
    setProductModal({ open: true, mode: "add", index: null });
  };

  const openEditProduct = (index) => {
    const p = products[index] || {};
    setProductForm({
      name: p.name || "",
      price: p.price || "",
      currency: p.currency || "INR",
      description: p.description || "",
      type: p.type || "product",
      image: p.image || "",
    });
    setProductPhotoPreview(p.image || "");
    setProductModal({ open: true, mode: "edit", index });
  };

  const closeProductModal = () => setProductModal((p) => ({ ...p, open: false }));

  const persistProducts = (nextProducts) => {
    setSavingProduct(true);
    logInstance
      .patch(
        "/card",
        { cardId: id, products: nextProducts },
        editAuth
      )
      .then(() => {
        message.success("Products updated");
        closeProductModal();
        fetchCardsData();
      })
      .catch((error) => {
        message.error(error?.response?.data?.message || "Failed to update products");
      })
      .finally(() => setSavingProduct(false));
  };

  const saveProduct = () => {
    if (!productForm.name.trim()) {
      message.error("Product name is required");
      return;
    }
    const entry = {
      name: productForm.name.trim(),
      price: productForm.price || "",
      currency: productForm.currency,
      description: productForm.description.trim() || "",
      type: productForm.type || "product",
      image: productForm.image || "",
    };
    const next = [...products];
    if (productModal.mode === "edit" && productModal.index !== null) {
      next[productModal.index] = { ...next[productModal.index], ...entry };
    } else {
      next.push(entry);
    }
    persistProducts(next);
  };

  const deleteProduct = (index) => {
    askConfirm("Delete this product?", () => {
      persistProducts(products.filter((_, i) => i !== index));
    });
  };

  const handleProductPhotoChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setProductPhotoPreview(URL.createObjectURL(file));
    setProductUploadingPhoto(true);
    uploadCardImageFile(file)
      .then((url) => setProductForm((p) => ({ ...p, image: url })))
      .catch(() => message.error("Failed to upload photo"))
      .finally(() => setProductUploadingPhoto(false));
  };

  const getYouTubeVideoId = (url) => {
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);
    return match && match[2].length === 11 ? match[2] : null;
  };

  const getYouTubeThumbnail = (videoId) => {
    return `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
  };

  const openAddVideo = () => {
    setVideoForm({ youtubeUrl: "" });
    setVideoGalleryModal(true);
  };

  const saveVideo = () => {
    if (!videoForm.youtubeUrl.trim()) {
      message.error("YouTube URL is required");
      return;
    }
    const videoId = getYouTubeVideoId(videoForm.youtubeUrl);
    if (!videoId) {
      message.error("Invalid YouTube URL");
      return;
    }
    setSavingVideo(true);
    const nextVideos = [
      ...(cardsData?.extendedProfile?.videos || []),
      { youtubeUrl: videoForm.youtubeUrl, videoId },
    ];
    logInstance
      .patch(
        "/card/extended-profile",
        { cardId: id, extendedProfile: { ...(cardsData.extendedProfile || {}), videos: nextVideos } },
        editAuth
      )
      .then(() => {
        message.success("Video added");
        setVideoGalleryModal(false);
        fetchCardsData();
      })
      .catch((error) => {
        message.error(error?.response?.data?.message || "Failed to add video");
      })
      .finally(() => setSavingVideo(false));
  };

  const deleteVideo = (index) => {
    askConfirm("Delete this video?", () => {
      const nextVideos = (cardsData?.extendedProfile?.videos || []).filter((_, i) => i !== index);
      setSavingVideo(true);
      logInstance
        .patch(
          "/card/extended-profile",
          { cardId: id, extendedProfile: { ...(cardsData.extendedProfile || {}), videos: nextVideos } },
          editAuth
        )
        .then(() => {
          message.success("Video deleted");
          fetchCardsData();
        })
        .catch((error) => {
          message.error(error?.response?.data?.message || "Failed to delete video");
        })
        .finally(() => setSavingVideo(false));
    });
  };

  const videosData = cardsData?.extendedProfile?.videos || [];

  const pdfData = cardsData?.extendedProfile?.brochure || null;

  const handlePdfFileChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    if (file.size > 50 * 1024 * 1024) {
      message.error("PDF must be less than 50 MB");
      return;
    }

    if (file.type !== "application/pdf") {
      message.error("Only PDF files are allowed");
      return;
    }

    setPdfUploadingFile(true);
    const reader = new FileReader();
    reader.onload = () => {
      logInstance
        .post("/card/upload-image", { cardId: id, image: reader.result }, editAuth)
        .then((res) => {
          setPdfFile({ name: file.name, url: res.data.url });
          message.success("PDF uploaded successfully");
        })
        .catch((error) => {
          console.error("PDF upload error:", error);
          message.error(error?.response?.data?.message || "Failed to upload PDF");
        })
        .finally(() => setPdfUploadingFile(false));
    };
    reader.onerror = () => {
      message.error("Failed to read PDF file");
      setPdfUploadingFile(false);
    };
    reader.readAsDataURL(file);
  };

  const savePdf = () => {
    if (!pdfFile) {
      message.error("No PDF file selected");
      return;
    }
    setSavingPdf(true);
    logInstance
      .patch(
        "/card/extended-profile",
        {
          cardId: id,
          extendedProfile: {
            ...(cardsData.extendedProfile || {}),
            brochure: pdfFile
          }
        },
        editAuth
      )
      .then(() => {
        message.success("Brochure updated");
        setPdfModalOpen(false);
        setPdfFile(null);
        fetchCardsData();
      })
      .catch((error) => {
        message.error(error?.response?.data?.message || "Failed to update brochure");
      })
      .finally(() => setSavingPdf(false));
  };

  const handlePdfDownload = async () => {
    if (!id) return;
    try {
      const response = await logInstance.get(`/card/download-pdf/${id}`, {
        responseType: "blob",
        headers: editHeaders
      });
      const url = URL.createObjectURL(response.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = pdfData.name || "brochure.pdf";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("PDF download error:", error);
      message.error("Failed to download PDF");
    }
  };

  const deletePdf = () => {
    askConfirm("Delete this brochure?", () => {
      setSavingPdf(true);
      logInstance
        .patch(
          "/card/extended-profile",
          {
            cardId: id,
            extendedProfile: {
              ...(cardsData.extendedProfile || {}),
              brochure: null
            }
          },
          editAuth
        )
        .then(() => {
          message.success("Brochure deleted");
          fetchCardsData();
        })
        .catch((error) => {
          message.error(error?.response?.data?.message || "Failed to delete brochure");
        })
        .finally(() => setSavingPdf(false));
    });
  };

  // Uploads a picked file to S3 (via /card/upload-image) and resolves with
  // the resulting URL — used everywhere a photo/logo is picked, so the saved
  // extendedProfile only ever holds a short URL string, never raw image
  // bytes. Storing base64 directly in extendedProfile used to mean every
  // single PATCH — even a plain text edit elsewhere — re-sent and re-saved
  // the whole multi-MB blob (that field spreads the entire existing
  // extendedProfile object on every save), which is why edits felt slow.
  const uploadCardImageFile = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        logInstance
          .post("/card/upload-image", { cardId: id, image: reader.result }, editAuth)
          .then((res) => resolve(res.data.url))
          .catch(reject);
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });

  const officeLocation = cardsData?.extendedProfile?.officeLocation || null;

  const openEditLocation = () => {
    setLocationForm(
      officeLocation
        ? { address: officeLocation.address || "", lat: officeLocation.lat, lng: officeLocation.lng, placeId: officeLocation.placeId || "" }
        : { address: "", lat: null, lng: null, placeId: "" }
    );
    setLocationModalOpen(true);
    loadGoogleMapsScript()
      .then(() => setMapsReady(true))
      .catch(() => message.error("Couldn't load Google Maps — check the API key"));
  };

  const closeLocationModal = () => setLocationModalOpen(false);

  // Attaches Places Autocomplete to the plain <input> once the modal is open
  // and the Maps script has loaded; detaches on close so reopening re-binds
  // cleanly to the (freshly remounted, thanks to destroyOnClose) input node.
  //
  // Marks the DOM node itself once bound (rather than relying on cleanup to
  // reset a ref) because React.StrictMode double-invokes this effect on
  // mount, and Google's legacy Autocomplete widget has no real destroy
  // method — clearInstanceListeners only removes our place_changed handler,
  // not its internal dropdown wiring, so a naive cleanup+recreate leaves two
  // bindings on the same node and the suggestions dropdown breaks after the
  // first use. A fresh reopen still gets a genuinely new node (destroyOnClose
  // on the Modal), so the flag naturally resets when it should.
  useEffect(() => {
    if (!locationModalOpen || !mapsReady || !locationInputRef.current) return;
    if (locationInputRef.current.dataset.placesBound) return;
    locationInputRef.current.dataset.placesBound = "true";
    const autocomplete = new window.google.maps.places.Autocomplete(locationInputRef.current, {
      fields: ["formatted_address", "geometry", "place_id"],
    });
    autocomplete.addListener("place_changed", () => {
      const place = autocomplete.getPlace();
      if (!place.geometry) return;
      setLocationForm({
        address: place.formatted_address || "",
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
        placeId: place.place_id || "",
      });
    });
  }, [locationModalOpen, mapsReady]);

  const persistLocation = (nextLocation) => {
    setSavingLocation(true);
    logInstance
      .patch(
        "/card/extended-profile",
        { cardId: id, extendedProfile: { ...(cardsData.extendedProfile || {}), officeLocation: nextLocation } },
        editAuth
      )
      .then(() => {
        message.success("Office location updated");
        closeLocationModal();
        fetchCardsData();
      })
      .catch((error) => {
        message.error(error?.response?.data?.message || "Failed to update office location");
      })
      .finally(() => setSavingLocation(false));
  };

  const saveLocation = () => {
    if (locationForm.lat == null || locationForm.lng == null) {
      message.error("Pick a location from the suggestions list");
      return;
    }
    persistLocation({ address: locationForm.address, lat: locationForm.lat, lng: locationForm.lng, placeId: locationForm.placeId });
  };

  const deleteLocation = () => {
    askConfirm("Remove this office location?", () => {
      persistLocation(null);
    });
  };

  const openInquiryModal = () => {
    setInquiryForm({ name: "", phone: "", email: "", message: "" });
    setInquiryModalOpen(true);
  };

  const submitInquiry = () => {
    if (!inquiryForm.name.trim() || !inquiryForm.phone.trim() || !inquiryForm.email.trim() || !inquiryForm.message.trim()) {
      message.error("All fields are required");
      return;
    }
    setSubmittingInquiry(true);
    logInstance
      .post("/profile-form/submit", {
        userId: cardsData.userId,
        name: inquiryForm.name.trim(),
        phnNumber: inquiryForm.phone.trim(),
        email: inquiryForm.email.trim(),
        message: inquiryForm.message.trim(),
        type: "inquiry",
      })
      .then(() => {
        message.success("Your inquiry has been sent!");
        setInquiryModalOpen(false);
      })
      .catch((error) => {
        message.error(error?.response?.data?.message || "Failed to send inquiry");
      })
      .finally(() => setSubmittingInquiry(false));
  };

  const generateVCF = () => {
    if (!cardsData) return;
    const yourName = cardsData.yourName || "No Name Available";
    const businessName = cardsData.businessName || "";
    const designation = cardsData.designation || "";
    const mobile = cardsData.mobile || "";
    const whatsapp = cardsData.whatsappNo || "";
    const email = cardsData.email || "";
    const website = cardsData.website ? `https://${cardsData.website}` : "";
    const fullName =
      [yourName, designation, businessName].filter(Boolean).join(" ") ||
      "No Name Available";
    const vcfData = `BEGIN:VCARD
VERSION:3.0
N:${fullName}
FN:${fullName}
ORG:${businessName}
TITLE:${designation}
TEL;TYPE=CELL:${mobile}
${whatsapp ? `TEL;TYPE=WHATSAPP:${whatsapp}` : ""}
EMAIL:${email}
${website ? `URL:${website}` : ""}
END:VCARD`.trim();

    const blob = new Blob([vcfData], { type: "text/vcard" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${fullName}.vcf`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const handleLinkClick = (event, link) => {
    if (!link) {
      event.preventDefault();
      message.error("Not Found");
    }
  };

  const shareCard = async () => {
    const shareUrl = `https://knowconnections.com/profile-card/${id}`;
    if (navigator.share) {
      try {
        await navigator.share({
          title: cardsData.businessName || "Digital Business Card",
          text: "Check out my digital business card",
          url: shareUrl,
        });
      } catch (err) {
        if (err.name !== "AbortError") {
          navigator.clipboard.writeText(shareUrl);
          message.success("Link copied!");
        }
      }
    } else {
      navigator.clipboard.writeText(shareUrl);
      message.success("Link copied to clipboard!");
    }
  };

  const shareViewLink = async () => {
    const shareUrl = `https://knowconnections.com/profile-card/${id}`;
    if (navigator.share) {
      try {
        await navigator.share({
          title: cardsData.businessName || "Digital Business Card",
          text: "Check out my digital business card",
          url: shareUrl,
        });
      } catch (err) {
        if (err.name !== "AbortError") {
          navigator.clipboard.writeText(shareUrl);
          message.success("Link copied!");
        }
      }
    } else {
      navigator.clipboard.writeText(shareUrl);
      message.success("Link copied to clipboard!");
    }
  };

  const shareEditLink = async () => {
    const shareUrl = `https://knowconnections.com/profile-card/${id}?session=${sessionId}`;
    if (navigator.share) {
      try {
        await navigator.share({
          title: `Edit ${cardsData.businessName || "Profile"}`,
          text: "Click to edit this profile",
          url: shareUrl,
        });
      } catch (err) {
        if (err.name !== "AbortError") {
          navigator.clipboard.writeText(shareUrl);
          message.success("Edit link copied!");
        }
      }
    } else {
      navigator.clipboard.writeText(shareUrl);
      message.success("Edit link copied to clipboard!");
    }
  };

  const themeLayouts = {
    "001": Theme001,
    "002": Theme002,
    "003": Theme003,
    "004": Theme004,
  };

  const ThemeComponent = themeLayouts[cardsData.theme] || Theme001;
  const cardColor = cardsData.color ? `#${cardsData.color.slice(2)}` : "#2986D6";

  const isLightColor = (hex) => {
    const h = hex.replace("#", "");
    if (h.length < 6) return false;
    const r = parseInt(h.slice(0, 2), 16);
    const g = parseInt(h.slice(2, 4), 16);
    const b = parseInt(h.slice(4, 6), 16);
    return (0.299 * r + 0.587 * g + 0.114 * b) / 255 > 0.85;
  };

  const buttonColor = isLightColor(cardColor) ? "#2986D6" : cardColor;
  const displayProducts = products.slice(0, visibleCount);
  const subtitle = [cardsData.designation, cardsData.businessName]
    .filter(Boolean)
    .join(" at ");

  const socialLinks = [
    { href: "https://www.instagram.com/know_connections/", icon: <FaInstagram />, color: "#E1306C" },
    { href: "https://www.facebook.com/knowconnections7", icon: <RiFacebookCircleLine />, color: "#1877F2" },
    { href: "https://wa.me/919742314395", icon: <FaWhatsapp />, color: "#25D366" },
    { href: "https://www.linkedin.com/company/know-connections", icon: <FaLinkedin />, color: "#0077B5" },
  ];

  return (
    <div
      style={{
        background: "#f5f6fa",
        maxWidth: 480,
        margin: "0 auto",
        minHeight: "100vh",
        fontFamily: "Arial, sans-serif",
        paddingBottom: 90,
      }}
    >
      {/* ══════════════ New profile header (Figma) ══════════════ */}
      <div
        style={{
          margin: "16px 16px 16px",
          borderRadius: 20,
          overflow: "hidden",
          background: "#fff",
          boxShadow: "0 2px 6px rgba(18,22,28,0.04), 0 12px 28px -12px rgba(18,22,28,0.10)",
        }}
      >
        <div
          className="flip-container"
          onClick={() => setCardModalOpen(true)}
          style={{ width: "100%", position: "relative", cursor: "pointer" }}
        >
          <div className={`flipper ${isFlipped ? "flipped" : ""}`}>
            <ThemeComponent
              cardsData={cardsData}
              defaultimage={defaultimage}
              onQrClick={(val) => setQrModal({ visible: true, value: val })}
            />
          </div>
        </div>

        <div style={{ marginTop: -80, marginLeft: 20, position: "relative", zIndex: 2, width: 96, display: cardModalOpen ? "none" : "block" }}>
          {(userImage || cardsData?.extendedProfile?.photo) ? (
            <img
              src={userImage || cardsData?.extendedProfile?.photo}
              alt={cardsData.yourName}
              style={{
                width: 96,
                height: 96,
                borderRadius: 16,
                border: "4px solid #fff",
                objectFit: "contain",
                background: "#fff",
                boxShadow: "0 2px 6px rgba(18,22,28,0.04), 0 12px 28px -12px rgba(18,22,28,0.10)",
              }}
            />
          ) : (
            <div
              style={{
                width: 96,
                height: 96,
                borderRadius: 16,
                border: "4px solid #fff",
                background: "linear-gradient(135deg,#2b3648,#4a5a72)",
                color: "#fff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 32,
                fontWeight: 800,
              }}
            >
              {(cardsData.yourName || "K").charAt(0).toUpperCase()}
            </div>
          )}
        </div>

        <div style={{ padding: "14px 20px 20px" }}>
          <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 8 }}>
            <h1
              style={{
                fontFamily: "'Montserrat', sans-serif",
                fontSize: 22,
                fontWeight: 800,
                letterSpacing: "-0.015em",
                color: "#12161C",
                margin: "0 0 3px",
              }}
            >
              {cardsData.yourName || "Name"}
            </h1>
            {isEditMode && (
              <button
                onClick={openEditIntro}
                aria-label="Edit intro"
                style={{ background: "none", border: "none", cursor: "pointer", padding: 4, marginTop: 2, flexShrink: 0 }}
              >
                <EditPencil />
              </button>
            )}
            {!isEditMode && !sessionId && (
              <Dropdown
                trigger={["click"]}
                placement="bottomRight"
                menu={{
                  items: [
                    {
                      key: "edit-profile",
                      label: "Edit Profile Link",
                      icon: (
                        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <path d="M12 20h9" />
                          <path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z" />
                        </svg>
                      ),
                    },
                  ],
                  onClick: ({ key }) => {
                    if (key === "edit-profile") setShowEditOtpModal(true);
                  },
                }}
              >
                <button
                  aria-label="More options"
                  style={{ background: "none", border: "none", cursor: "pointer", padding: 4, marginTop: 2, flexShrink: 0, color: "#6B7480", display: "flex" }}
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                    <circle cx="12" cy="5" r="2" />
                    <circle cx="12" cy="12" r="2" />
                    <circle cx="12" cy="19" r="2" />
                  </svg>
                </button>
              </Dropdown>
            )}
          </div>
          <p style={{ fontSize: 14.5, fontWeight: 700, color: "#1467E0", margin: "0 0 6px" }}>
            {cardsData.designation || "Founder & Managing Director"}
          </p>
          {cardsData?.extendedProfile?.heading && (
            <p style={{ fontSize: 13, fontStyle: "italic", color: "#6B7480", margin: "0 0 12px" }}>
              {cardsData.extendedProfile.heading}
            </p>
          )}
          <div style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 13.5, color: "#6B7480", marginBottom: 16 }}>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="4" y="3" width="16" height="18" rx="1" />
              <path d="M9 8h1M14 8h1M9 12h1M14 12h1M9 16h1M14 16h1" />
            </svg>
            {cardsData.businessName || "KnowConnections"}
          </div>

          {(isEditMode || (cardsData?.extendedProfile?.stats && Array.isArray(cardsData.extendedProfile.stats) && cardsData.extendedProfile.stats.length > 0)) && (
          <div style={{ marginBottom: 16 }}>
            {isEditMode && (
              <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 10 }}>
                <button
                  onClick={openAddStat}
                  style={{ display: "flex", alignItems: "center", gap: 4, border: "none", background: "#E9F1FE", color: "#0D4FB8", fontWeight: 700, fontSize: 12.5, borderRadius: 999, padding: "6px 12px", cursor: "pointer", flexShrink: 0, whiteSpace: "nowrap" }}
                >
                  <span style={{ fontSize: 14, lineHeight: 1 }}>+</span> Add Stat
                </button>
              </div>
            )}
            <div style={{ display: "grid", gridTemplateColumns: `repeat(${Math.min(stats.length, 4)}, 1fr)`, gap: 4 }}>
              {stats.map((s, i) => (
                <div
                  key={i}
                  style={{
                    background: "#E9F1FE",
                    borderRadius: 14,
                    padding: "14px 6px",
                    textAlign: "center",
                    position: "relative",
                    cursor: isEditMode ? "pointer" : "default",
                  }}
                >
                  {isEditMode && (
                    <div style={{ position: "absolute", top: 4, right: 4, display: "flex", gap: 4 }}>
                      <button
                        onClick={() => openEditStat(i)}
                        aria-label="Edit stat"
                        style={{ background: "none", border: "none", cursor: "pointer", padding: 2, flexShrink: 0 }}
                      >
                        <EditPencil size={12} />
                      </button>
                      <button
                        onClick={() => deleteStat(i)}
                        aria-label="Delete stat"
                        style={{ background: "none", border: "none", cursor: "pointer", padding: 2, flexShrink: 0 }}
                      >
                        <CloseIcon size={12} />
                      </button>
                    </div>
                  )}
                  <div style={{ fontSize: 16, fontWeight: 800, color: s.green ? "#1E9E5A" : "#1467E0" }}>{s.value}</div>
                  <div
                    style={{
                      fontSize: 9,
                      fontWeight: 700,
                      letterSpacing: "0.04em",
                      color: "#6B7480",
                      textTransform: "uppercase",
                      marginTop: 2,
                    }}
                  >
                    {s.label}
                  </div>
                </div>
              ))}
            </div>
          </div>
          )}

          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginBottom: 12 }}>
            <button
              onClick={generateVCF}
              style={{
                border: "none",
                borderRadius: 10,
                padding: "13px 16px",
                fontSize: 14.5,
                fontWeight: 700,
                background: "#1467E0",
                color: "#fff",
                cursor: "pointer",
              }}
            >
              Save Contact
            </button>
            <button
              onClick={openShareModal}
              style={{
                borderRadius: 10,
                padding: "13px 16px",
                fontSize: 14.5,
                fontWeight: 700,
                background: "#fff",
                color: "#12161C",
                border: "1.5px solid #E4E8EE",
                cursor: "pointer",
              }}
            >
              Share Contact
            </button>
          </div>

          <button
            onClick={() => setBookingVisible(true)}
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              gap: 10,
              background: "#E9F1FE",
              color: "#0D4FB8",
              border: "none",
              borderRadius: 10,
              padding: "13px 16px",
              fontSize: 13.5,
              fontWeight: 700,
              cursor: "pointer",
            }}
          >
            <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="3" y="5" width="18" height="16" rx="2" />
              <path d="M3 10h18M8 3v4M16 3v4" />
            </svg>
            Direct Message &amp; Schedule Meeting
            {isEditMode && <EditPencil size={13} style={{ marginLeft: "auto" }} />}
          </button>

          {sessionId && (
            <>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginTop: 12, marginBottom: 12 }}>
                <button
                  onClick={shareEditLink}
                  style={{
                    borderRadius: 10,
                    padding: "13px 16px",
                    fontSize: 13.5,
                    fontWeight: 700,
                    background: "#E8F5E9",
                    color: "#1E9E5A",
                    border: "none",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 8
                  }}
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="18" cy="5" r="3" />
                    <circle cx="6" cy="12" r="3" />
                    <circle cx="18" cy="19" r="3" />
                    <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" />
                    <line x1="15.41" y1="6.51" x2="8.59" y2="10.49" />
                  </svg>
                  Share Edit Link
                </button>
                <button
                  onClick={shareViewLink}
                  style={{
                    borderRadius: 10,
                    padding: "13px 16px",
                    fontSize: 13.5,
                    fontWeight: 700,
                    background: "#E9F1FE",
                    color: "#0D4FB8",
                    border: "none",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 8
                  }}
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="18" cy="5" r="3" />
                    <circle cx="6" cy="12" r="3" />
                    <circle cx="18" cy="19" r="3" />
                    <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" />
                    <line x1="15.41" y1="6.51" x2="8.59" y2="10.49" />
                  </svg>
                  Share View Link
                </button>
              </div>
              <EditLogoutButton cardId={id} style={{ width: "100%"}} />
            </>
          )}
        </div>
      </div>

      {/* ══════════════ Services — grid 401 Fill × 442 Hug, card 186×213 ══════════════ */}
      {(isEditMode || (cardsData?.extendedProfile?.services && cardsData.extendedProfile.services.length > 0)) && (
      <div style={{ margin: "0 16px 16px" }}>
        <div style={{ padding: "4px 4px 12px", display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 8 }}>
          <div>
            <h2 style={{ fontSize: 18, fontWeight: 800, color: "#12161C", margin: "0 0 3px", letterSpacing: "-0.01em" }}>
              Services
            </h2>
            <p style={{ fontSize: 12.5, color: "#6B7480", margin: 0 }}>Live tools powering instanceceous connections</p>
          </div>
          {isEditMode && (
            <button
              onClick={openAddService}
              style={{ display: "flex", alignItems: "center", gap: 4, border: "none", background: "#E9F1FE", color: "#0D4FB8", fontWeight: 700, fontSize: 12.5, borderRadius: 999, padding: "6px 12px", cursor: "pointer", flexShrink: 0, whiteSpace: "nowrap" }}
            >
              <span style={{ fontSize: 14, lineHeight: 1 }}>+</span> Add
            </button>
          )}
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px 29px" }}>
          {services.map((s, i) => (
            <div key={i} style={{ height: 213, boxSizing: "border-box", background: "#fff", borderRadius: 14, padding: "16px 14px", boxShadow: "0 2px 6px rgba(18,22,28,0.04), 0 12px 28px -12px rgba(18,22,28,0.10)", display: "flex", flexDirection: "column" }}>
              <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", marginBottom: 10 }}>
                <span style={{ alignSelf: "flex-start", fontSize: 10.5, fontWeight: 700, color: "#0D4FB8", background: "#E9F1FE", borderRadius: 999, padding: "4px 10px" }}>
                  {s.badge}
                </span>
                {isEditMode && (
                  <button
                    onClick={() => openEditService(i)}
                    aria-label="Edit service"
                    style={{ background: "none", border: "none", cursor: "pointer", padding: 2, marginLeft: 6, flexShrink: 0 }}
                  >
                    <EditPencil size={13} />
                  </button>
                )}
              </div>
              <h3 style={{ fontSize: 14.5, fontWeight: 700, margin: "0 0 6px", color: "#12161C" }}>{s.title}</h3>
              <p style={{ fontSize: 12, color: "#6B7480", margin: "0 0 14px", flex: 1, lineHeight: 1.5 }}>{s.desc}</p>
              <button style={{ border: "none", background: "#E9F1FE", color: "#0D4FB8", fontWeight: 700, fontSize: 12.5, borderRadius: 9, padding: "9px 10px", cursor: "pointer" }}>
                {s.cta}
              </button>
            </div>
          ))}
        </div>
      </div>
      )}

      {/* ══════════════ Products & Services ══════════════ */}
      {displayProducts.length > 0 && (
        <div style={{ margin: "0 16px 16px" }}>
          <div style={{ padding: "4px 4px 12px", display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 8 }}>
            <div>
              <h2 style={{ fontSize: 18, fontWeight: 800, color: "#12161C", margin: "0 0 3px", letterSpacing: "-0.01em" }}>
                Products & Services
              </h2>
              <p style={{ fontSize: 12.5, color: "#6B7480", margin: 0 }}>Explore what we offer</p>
            </div>
            {isEditMode && (
              <button
                onClick={openAddProduct}
                style={{ display: "flex", alignItems: "center", gap: 4, border: "none", background: "#E9F1FE", color: "#0D4FB8", fontWeight: 700, fontSize: 12.5, borderRadius: 999, padding: "6px 12px", cursor: "pointer", flexShrink: 0, whiteSpace: "nowrap" }}
              >
                <span style={{ fontSize: 14, lineHeight: 1 }}>+</span> Add
              </button>
            )}
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
            {displayProducts.map((product, i) => (
              <div key={product._id} style={{ position: "relative" }}>
                {isEditMode && (
                  <div style={{ position: "absolute", top: 12, right: 12, display: "flex", gap: 6, zIndex: 10 }}>
                    <button
                      onClick={() => openEditProduct(i)}
                      aria-label="Edit product"
                      style={{ background: "none", border: "none", cursor: "pointer", padding: 4, flexShrink: 0 }}
                    >
                      <EditPencil size={14} />
                    </button>
                    <button
                      onClick={() => deleteProduct(i)}
                      aria-label="Delete product"
                      style={{ background: "none", border: "none", cursor: "pointer", padding: 4, flexShrink: 0 }}
                    >
                      <TrashIcon size={14} />
                    </button>
                  </div>
                )}
                <ProductItem product={product} cardColor={cardColor} />
              </div>
            ))}
          </div>
          {visibleCount < products.length && (
            <button
              onClick={() => setVisibleCount((c) => c + 1)}
              style={{
                display: "block",
                width: "100%",
                marginTop: 12,
                padding: "10px 0",
                background: "#fff",
                border: `1.5px solid ${cardColor}`,
                borderRadius: 8,
                color: cardColor,
                fontWeight: 600,
                fontSize: 13,
                cursor: "pointer",
              }}
            >
              Show Next ({products.length - visibleCount} remaining)
            </button>
          )}
        </div>
      )}

      {/* ══════════════ Gallery ══════════════ */}
      {(isEditMode || (features && features.length > 0 && features !== DEFAULT_FEATURES)) && (
      <div style={{ margin: "0 16px 16px" }}>
        <div style={{ padding: "4px 4px 12px", display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 8 }}>
          <div>
            <h2 style={{ fontSize: 18, fontWeight: 800, color: "#12161C", margin: "0 0 3px", letterSpacing: "-0.01em" }}>
              Gallery
            </h2>
            <p style={{ fontSize: 12.5, color: "#6B7480", margin: 0 }}>Showcase your top work, media, and presentations</p>
          </div>
          {isEditMode && (
            <button
              onClick={openAddFeature}
              style={{ display: "flex", alignItems: "center", gap: 4, border: "none", background: "#E9F1FE", color: "#0D4FB8", fontWeight: 700, fontSize: 12.5, borderRadius: 999, padding: "6px 12px", cursor: "pointer", flexShrink: 0, whiteSpace: "nowrap" }}
            >
              <span style={{ fontSize: 14, lineHeight: 1 }}>+</span> Add
            </button>
          )}
        </div>
        {/* card 401×~345, media 387×231, thumb 121×74.74 (7px inset each side) */}
        <div style={{ background: "#fff", borderRadius: 14, boxShadow: "0 2px 6px rgba(18,22,28,0.04), 0 12px 28px -12px rgba(18,22,28,0.10)", padding: 7, position: "relative" }}>
          {isEditMode && features.length > 0 && (
            <div style={{ position: "absolute", top: 16, right: 16, zIndex: 2, display: "flex", gap: 8 }}>
              <button
                onClick={deleteActiveFeature}
                aria-label="Delete feature"
                style={{ width: 30, height: 30, borderRadius: "50%", background: "rgba(255,255,255,0.92)", border: "none", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}
              >
                <TrashIcon color="#12161C" />
              </button>
              <button
                onClick={openEditFeature}
                aria-label="Edit feature"
                style={{ width: 30, height: 30, borderRadius: "50%", background: "rgba(255,255,255,0.92)", border: "none", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}
              >
                <EditPencil color="#12161C" />
              </button>
            </div>
          )}
          <div
            style={{
              height: 231,
              borderRadius: 10,
              position: "relative",
              display: "flex",
              alignItems: "flex-end",
              padding: 16,
              background: activeFeature.image ? "#0B1E45" : "linear-gradient(160deg, #14203A 0%, #1467E0 100%)",
              overflow: "hidden",
            }}
          >
            {activeFeature.image && (
              <img
                src={activeFeature.image}
                alt=""
                style={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover" }}
              />
            )}
            {!activeFeature.image && (
              <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="#cfe0fb" strokeWidth="1.6" style={{ position: "absolute", top: 16, right: 16, opacity: 0.85 }}>
                <path d="M2 8.82a15 15 0 0 1 20 0" />
                <path d="M5 12.86a10 10 0 0 1 14 0" />
                <path d="M8.5 16.9a5 5 0 0 1 7 0" />
                <circle cx="12" cy="20" r="1" />
              </svg>
            )}
            <div style={{ position: "relative", zIndex: 1 }}>
              <span style={{ display: "inline-block", fontSize: 10, fontWeight: 800, letterSpacing: "0.04em", color: "#0B1E45", background: "#fff", borderRadius: 999, padding: "4px 10px", marginBottom: 8 }}>
                {activeFeature.heading || "GLOBAL KEYNOTE 2024"}
              </span>
              <h3 style={{ color: "#fff", fontSize: 15, fontWeight: 700, margin: 0, lineHeight: 1.3, maxWidth: "82%" }}>
                {activeFeature.subheading || "Enterprise Networking & NFC Ecosystems"}
              </h3>
            </div>
          </div>
          <div style={{ display: "grid", gridTemplateColumns: `repeat(${Math.min(features.length, 3) || 1},1fr)`, gap: 12, marginTop: 12 }}>
            {features.map((f, i) => (
              <button
                key={i}
                onClick={() => setActiveFeatureIndex(i)}
                style={{
                  height: 74.74,
                  borderRadius: 9,
                  border: i === activeFeatureIndex ? "2px solid #1467E0" : "2px solid transparent",
                  background: f.image ? `url(${f.image}) center/cover no-repeat` : "linear-gradient(140deg,#dbe4f3,#eef2fa)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxSizing: "border-box",
                  padding: 0,
                  cursor: "pointer",
                }}
              >
                {!f.image && (
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#9AA3AF" strokeWidth="1.6">
                    <rect x="3" y="4" width="18" height="14" rx="2" />
                    <path d="M3 15l4-4 4 4 5-6 5 6" />
                  </svg>
                )}
              </button>
            ))}
          </div>
        </div>
      </div>
      )}

      {/* ══════════════ YouTube Video Gallery ══════════════ */}
      {(videosData.length > 0 || isEditMode) && (
        <div style={{ margin: "0 16px 16px" }}>
          <div style={{ padding: "4px 4px 12px", display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 8 }}>
            <div>
              <h2 style={{ fontSize: 18, fontWeight: 800, color: "#12161C", margin: "0 0 3px", letterSpacing: "-0.01em" }}>
                Videos
              </h2>
              <p style={{ fontSize: 12.5, color: "#6B7480", margin: 0 }}>Check out our latest content</p>
            </div>
            {isEditMode && (
              <button
                onClick={openAddVideo}
                style={{ display: "flex", alignItems: "center", gap: 4, border: "none", background: "#E9F1FE", color: "#0D4FB8", fontWeight: 700, fontSize: 12.5, borderRadius: 999, padding: "6px 12px", cursor: "pointer", flexShrink: 0, whiteSpace: "nowrap" }}
              >
                <span style={{ fontSize: 14, lineHeight: 1 }}>+</span> Add
              </button>
            )}
          </div>
          <div style={{ background: "#fff", borderRadius: 14, boxShadow: "0 2px 6px rgba(18,22,28,0.04), 0 12px 28px -12px rgba(18,22,28,0.10)", padding: 7, marginBottom: 12 }}>
            {videosData.length === 0 ? (
              <div
                style={{
                  height: 231,
                  borderRadius: 10,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "#f5f5f5",
                  padding: 20,
                  textAlign: "center",
                }}
              >
                <svg width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="#ccc" strokeWidth="1.5" style={{ marginBottom: 12 }}>
                  <polygon points="5 3 19 12 5 21 5 3" />
                </svg>
                <p style={{ fontSize: 14, color: "#999", margin: "0 0 12px" }}>No videos yet</p>
                {isEditMode && (
                  <button
                    onClick={openAddVideo}
                    style={{
                      padding: "8px 16px",
                      background: "#1467E0",
                      color: "#fff",
                      border: "none",
                      borderRadius: 8,
                      fontWeight: 600,
                      cursor: "pointer",
                      fontSize: 13,
                    }}
                  >
                    + Add Video
                  </button>
                )}
              </div>
            ) : (
              <>
            <div
              style={{
                height: 231,
                borderRadius: 10,
                position: "relative",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#000",
                overflow: "hidden",
                cursor: "pointer",
              }}
              onClick={() => window.open(`https://www.youtube.com/watch?v=${videosData[activeVideoIndex]?.videoId}`, "_blank")}
            >
              <img
                src={getYouTubeThumbnail(videosData[activeVideoIndex]?.videoId)}
                alt="Video thumbnail"
                style={{ width: "100%", height: "100%", objectFit: "cover", position: "absolute" }}
              />
              <svg width="60" height="60" viewBox="0 0 24 24" fill="#fff" opacity="0.9" style={{ position: "relative", zIndex: 2 }}>
                <polygon points="5 3 19 12 5 21 5 3" />
              </svg>
              {isEditMode && (
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    deleteVideo(activeVideoIndex);
                  }}
                  style={{
                    position: "absolute",
                    top: 8,
                    right: 8,
                    width: 30,
                    height: 30,
                    borderRadius: "50%",
                    background: "rgba(0,0,0,0.6)",
                    border: "none",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    zIndex: 3,
                  }}
                >
                  <CloseIcon color="#fff" size={16} />
                </button>
              )}
            </div>
            {videosData.length > 1 && (
              <div style={{ display: "grid", gridTemplateColumns: `repeat(${Math.min(videosData.length, 3)}, 1fr)`, gap: 8, marginTop: 12 }}>
                {videosData.map((video, i) => (
                  <div
                    key={i}
                    onClick={() => setActiveVideoIndex(i)}
                    style={{
                      height: 70,
                      borderRadius: 8,
                      cursor: "pointer",
                      border: i === activeVideoIndex ? "2px solid #1467E0" : "2px solid transparent",
                      overflow: "hidden",
                      backgroundImage: `url(${getYouTubeThumbnail(video.videoId)})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      position: "relative",
                    }}
                  >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="#fff" style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }}>
                      <polygon points="5 3 19 12 5 21 5 3" />
                    </svg>
                  </div>
                ))}
              </div>
            )}
            </>
            )}
          </div>
        </div>
      )}

      {/* ══════════════ About ══════════════ */}
      {(isEditMode || cardsData?.extendedProfile?.about) && (
      <div style={{ margin: "0 16px 16px" }}>
        <div style={{ padding: "4px 4px 12px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <h2 style={{ fontSize: 18, fontWeight: 800, color: "#12161C", margin: 0, letterSpacing: "-0.01em" }}>About</h2>
          {isEditMode && (
            <button
              onClick={openEditAbout}
              aria-label="Edit about"
              style={{ background: "none", border: "none", cursor: "pointer", padding: 4 }}
            >
              <EditPencil />
            </button>
          )}
        </div>
        <div style={{ background: "#fff", borderRadius: 20, boxShadow: "0 2px 6px rgba(18,22,28,0.04), 0 12px 28px -12px rgba(18,22,28,0.10)", padding: 20 }}>
          {aboutParagraphs.map((para, i) => (
            <p key={i} style={{ fontSize: 13.5, color: "#6B7480", margin: i === aboutParagraphs.length - 1 ? "0 0 16px" : "0 0 12px" }}>
              {para}
            </p>
          ))}
          {(isEditMode || cardsData?.extendedProfile?.about) && (
            <div style={{ borderLeft: "3px solid #1467E0", background: "#E9F1FE", borderRadius: "0 10px 10px 0", padding: "14px 16px", fontSize: 13, fontStyle: "italic", color: "#12161C", margin: "0 0 18px" }}>
              "{cardsData.aiDescription || "To bridge communication gaps and empower meaningful professional and social relationships through an intuitive, secure digital networking platform. Our goal is to transform how people connect, share insights, and build lasting communities in an increasingly interconnected world."}"
            </div>
          )}
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 10 }}>
            <h4 style={{ fontSize: 14, fontWeight: 700, color: "#12161C", margin: 0 }}>Certifications &amp; Badges</h4>
            {isEditMode && (
              <button
                onClick={openAddCert}
                style={{ display: "flex", alignItems: "center", gap: 4, border: "none", background: "#E9F1FE", color: "#0D4FB8", fontWeight: 700, fontSize: 12.5, borderRadius: 999, padding: "5px 11px", cursor: "pointer", flexShrink: 0, whiteSpace: "nowrap" }}
              >
                <span style={{ fontSize: 14, lineHeight: 1 }}>+</span> Add
              </button>
            )}
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: 10, marginBottom: 18 }}>
            {certifications.map((c, i) => (
              <div key={i} style={{ display: "flex", alignItems: "center", gap: 10, background: "#f5f6fa", borderRadius: 10, padding: "12px 14px", fontSize: 13, fontWeight: 600, color: "#12161C" }}>
                <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#1467E0" strokeWidth="2">
                  <path d="M12 2l8 4v6c0 5-3.4 8.4-8 10-4.6-1.6-8-5-8-10V6l8-4z" />
                  <path d="M9 12l2 2 4-4" />
                </svg>
                <span style={{ flex: 1 }}>{c}</span>
                {isEditMode && (
                  <>
                    <button
                      onClick={() => deleteCert(i)}
                      aria-label="Delete certification"
                      style={{ background: "none", border: "none", cursor: "pointer", padding: 2, flexShrink: 0 }}
                    >
                      <CloseIcon />
                    </button>
                    <button
                      onClick={() => openEditCert(i)}
                      aria-label="Edit certification"
                      style={{ background: "none", border: "none", cursor: "pointer", padding: 2, flexShrink: 0 }}
                    >
                      <EditPencil size={13} />
                    </button>
                  </>
                )}
              </div>
            ))}
          </div>
          <button onClick={openInquiryModal} style={{ width: "100%", border: "none", background: "#2A84FF", color: "#fff", fontWeight: 700, fontSize: 14, borderRadius: 10, padding: "13px 0", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", gap: 8 }}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2"><path d="M21 11.5a8.4 8.4 0 0 1-8.9 8.4 9 9 0 0 1-3-.5L4 21l1.6-4.9A8.3 8.3 0 0 1 4 12.5 8.4 8.4 0 0 1 12.6 4a8.3 8.3 0 0 1 8.4 7.5z" /></svg>
            Inquiries
          </button>
        </div>
      </div>
      )}

      {/* ══════════════ Testimonials ══════════════ */}
      {(isEditMode || (testimonials && testimonials.length > 0 && testimonials !== DEFAULT_TESTIMONIALS)) && (
      <div style={{ margin: "0 16px 16px" }}>
        <div style={{ padding: "4px 4px 12px", display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 8 }}>
          <div>
            <h2 style={{ fontSize: 18, fontWeight: 800, color: "#12161C", margin: "0 0 3px", letterSpacing: "-0.01em" }}>Testimonials</h2>
            <p style={{ fontSize: 12.5, color: "#6B7480", margin: 0 }}>What people say about us</p>
          </div>
          {isEditMode && (
            <button
              onClick={openAddTestimonial}
              style={{ display: "flex", alignItems: "center", gap: 4, border: "none", background: "#E9F1FE", color: "#0D4FB8", fontWeight: 700, fontSize: 12.5, borderRadius: 999, padding: "6px 12px", cursor: "pointer", flexShrink: 0, whiteSpace: "nowrap" }}
            >
              <span style={{ fontSize: 14, lineHeight: 1 }}>+</span> Add
            </button>
          )}
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
          {testimonials.map((t, i) => (
            <div key={i} style={{ background: "#fff", borderRadius: 14, boxShadow: "0 2px 6px rgba(18,22,28,0.04), 0 12px 28px -12px rgba(18,22,28,0.10)", padding: 16 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 9, marginBottom: 10 }}>
                {t.photo ? (
                  <img src={t.photo} alt={t.name} style={{ width: 34, height: 34, borderRadius: "50%", objectFit: "cover", flexShrink: 0 }} />
                ) : (
                  <div style={{ width: 34, height: 34, borderRadius: "50%", background: "linear-gradient(135deg,#e2996b,#c96a4e)", color: "#fff", fontSize: 12, fontWeight: 800, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                    {getInitials(t.name)}
                  </div>
                )}
                <div>
                  <div style={{ fontSize: 12.5, fontWeight: 700, lineHeight: 1.25 }}>{t.name}</div>
                  <div style={{ fontSize: 11, color: "#9AA3AF" }}>{t.role}</div>
                </div>
              </div>
              <p style={{ fontSize: 12, color: "#6B7480", margin: "0 0 10px", lineHeight: 1.5 }}>{t.quote}</p>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <div style={{ color: "#F5A524", fontSize: 12, letterSpacing: 1 }}>
                  {"★".repeat(t.rating || 5)}
                  {"☆".repeat(5 - (t.rating || 5))}
                </div>
                {isEditMode && (
                  <div style={{ display: "flex", gap: 8 }}>
                    <button
                      onClick={() => deleteTestimonial(i)}
                      aria-label="Delete testimonial"
                      style={{ background: "none", border: "none", cursor: "pointer", padding: 2 }}
                    >
                      <CloseIcon />
                    </button>
                    <button
                      onClick={() => openEditTestimonial(i)}
                      aria-label="Edit testimonial"
                      style={{ background: "none", border: "none", cursor: "pointer", padding: 2 }}
                    >
                      <EditPencil size={13} />
                    </button>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
      )}

      {/* ══════════════ PDF Brochure ══════════════ */}
      {(isEditMode || pdfData) && (
        <div style={{ margin: "0 16px 16px" }}>
          <div style={{ padding: "4px 4px 12px", display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 8 }}>
            <div>
              <h2 style={{ fontSize: 18, fontWeight: 800, color: "#12161C", margin: "0 0 3px", letterSpacing: "-0.01em" }}>Download Brochure</h2>
              <p style={{ fontSize: 12.5, color: "#6B7480", margin: 0 }}>Get our detailed information</p>
            </div>
            {isEditMode && !pdfData && (
              <button
                onClick={() => setPdfModalOpen(true)}
                style={{ display: "flex", alignItems: "center", gap: 4, border: "none", background: "#E9F1FE", color: "#0D4FB8", fontWeight: 700, fontSize: 12.5, borderRadius: 999, padding: "6px 12px", cursor: "pointer", flexShrink: 0, whiteSpace: "nowrap" }}
              >
                <span style={{ fontSize: 14, lineHeight: 1 }}>+</span> Upload
              </button>
            )}
          </div>
          {pdfData ? (
            <div style={{ background: "#fff", borderRadius: 14, boxShadow: "0 2px 6px rgba(18,22,28,0.04), 0 12px 28px -12px rgba(18,22,28,0.10)", padding: 16, display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12, position: "relative" }}>
              <div style={{ display: "flex", alignItems: "center", gap: 12, flex: 1 }}>
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#E5484D" strokeWidth="2" style={{ flexShrink: 0 }}>
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                  <polyline points="14 2 14 8 20 8" />
                </svg>
                <div style={{ minWidth: 0, flex: 1 }}>
                  <p style={{ fontSize: 13, fontWeight: 600, color: "#12161C", margin: "0 0 4px", wordBreak: "break-word" }}>{pdfData.name}</p>
                  <p style={{ fontSize: 11, color: "#9AA3AF", margin: 0 }}>PDF Document</p>
                </div>
              </div>
              <button
                onClick={handlePdfDownload}
                style={{
                  padding: "8px 16px",
                  background: "#1467E0",
                  color: "#fff",
                  border: "none",
                  borderRadius: 8,
                  fontWeight: 600,
                  fontSize: 13,
                  cursor: "pointer",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 6,
                  flexShrink: 0,
                }}
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                  <polyline points="7 10 12 15 17 10" />
                  <line x1="12" y1="15" x2="12" y2="3" />
                </svg>
                Download
              </button>
              {isEditMode && (
                <button
                  onClick={() => deletePdf()}
                  style={{ background: "none", border: "none", cursor: "pointer", padding: 4, color: "#E5484D", flexShrink: 0 }}
                >
                  <TrashIcon />
                </button>
              )}
            </div>
          ) : (
            isEditMode && (
              <div style={{ background: "#fff", borderRadius: 14, boxShadow: "0 2px 6px rgba(18,22,28,0.04), 0 12px 28px -12px rgba(18,22,28,0.10)", padding: 20, textAlign: "center", color: "#999" }}>
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" style={{ margin: "0 auto 12px", opacity: 0.5 }}>
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                  <polyline points="14 2 14 8 20 8" />
                </svg>
                <p style={{ fontSize: 13, margin: "0 0 4px" }}>No brochure uploaded</p>
                <p style={{ fontSize: 11, margin: 0 }}>Upload a PDF (max 50 MB)</p>
              </div>
            )
          )}
        </div>
      )}

      {/* ══════════════ Contact info ══════════════ */}
      {(isEditMode || (contacts && contacts.length > 0 && contacts !== DEFAULT_CONTACTS)) && (
      <div style={{ margin: "0 16px 16px" }}>
        <div style={{ padding: "4px 4px 12px", display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 8 }}>
          <div>
            <h2 style={{ fontSize: 18, fontWeight: 800, color: "#12161C", margin: "0 0 3px", letterSpacing: "-0.01em" }}>Contact info</h2>
            <p style={{ fontSize: 12.5, color: "#6B7480", margin: 0 }}>Direct verified communication channels</p>
          </div>
          {isEditMode && (
            <button
              onClick={openAddContact}
              style={{ display: "flex", alignItems: "center", gap: 4, border: "none", background: "#E9F1FE", color: "#0D4FB8", fontWeight: 700, fontSize: 12.5, borderRadius: 999, padding: "6px 12px", cursor: "pointer", flexShrink: 0, whiteSpace: "nowrap" }}
            >
              <span style={{ fontSize: 14, lineHeight: 1 }}>+</span> Add
            </button>
          )}
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          {contacts.map((c, i) => (
            <div key={i} style={{ display: "flex", alignItems: "center", gap: 12, background: "#fff", borderRadius: 10, padding: "15px 14px", boxShadow: "0 2px 6px rgba(18,22,28,0.04), 0 12px 28px -12px rgba(18,22,28,0.10)" }}>
              <div style={{ width: 36, height: 36, borderRadius: 9, background: "#E9F1FE", color: "#1467E0", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, overflow: "hidden" }}>
                {c.image ? (
                  <img src={c.image} alt={c.label} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                ) : (
                  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">{renderContactIconPaths(c.iconType)}</svg>
                )}
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: "0.04em", color: "#9AA3AF", textTransform: "uppercase" }}>{c.label}</div>
                <div style={{ fontSize: 13.5, fontWeight: 600, color: "#12161C", marginTop: 1 }}>{c.value}</div>
              </div>
              {isEditMode && (
                <div style={{ display: "flex", gap: 8, flexShrink: 0 }}>
                  <button
                    onClick={() => deleteContact(i)}
                    aria-label="Delete contact"
                    style={{ background: "none", border: "none", cursor: "pointer", padding: 2 }}
                  >
                    <CloseIcon />
                  </button>
                  <button
                    onClick={() => openEditContact(i)}
                    aria-label="Edit contact"
                    style={{ background: "none", border: "none", cursor: "pointer", padding: 2 }}
                  >
                    <EditPencil size={13} />
                  </button>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
      )}

      {/* ══════════════ Office Location ══════════════ */}
      {(isEditMode || officeLocation) && (
      <div style={{ margin: "0 16px 16px" }}>
        <div style={{ padding: "4px 4px 12px" }}>
          <h2 style={{ fontSize: 18, fontWeight: 800, color: "#12161C", margin: 0, letterSpacing: "-0.01em" }}>Office Location</h2>
        </div>
        <div style={{ background: "#fff", borderRadius: 20, boxShadow: "0 2px 6px rgba(18,22,28,0.04), 0 12px 28px -12px rgba(18,22,28,0.10)", overflow: "hidden" }}>
          <div
            onClick={officeLocation ? () => window.open(googleDirectionsUrl(officeLocation.lat, officeLocation.lng), "_blank") : undefined}
            style={{ height: 154, position: "relative", cursor: officeLocation ? "pointer" : "default" }}
          >
            {officeLocation ? (
              <img
                src={staticMapUrl(officeLocation.lat, officeLocation.lng, 380, 154)}
                alt="Office location map"
                style={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover" }}
              />
            ) : (
              <>
                <div
                  style={{
                    position: "absolute",
                    inset: 0,
                    background:
                      "linear-gradient(0deg, rgba(20,103,224,.10), rgba(20,103,224,.10)), repeating-linear-gradient(0deg, #cfe0f5 0 1px, #dcebfa 1px 34px), repeating-linear-gradient(90deg, #cfe0f5 0 1px, #dcebfa 1px 34px)",
                  }}
                />
                <div
                  style={{
                    position: "absolute",
                    left: "50%",
                    top: "46%",
                    width: 28,
                    height: 28,
                    borderRadius: "50% 50% 50% 0",
                    background: "#1467E0",
                    transform: "translate(-50%,-100%) rotate(-45deg)",
                    boxShadow: "0 3px 8px rgba(20,103,224,0.4)",
                  }}
                />
              </>
            )}
            <div
              style={{ position: "absolute", left: 12, bottom: 12, background: "rgba(11,20,32,0.85)", color: "#fff", fontSize: 11.5, fontWeight: 600, padding: "7px 12px", borderRadius: 8, display: "flex", alignItems: "center", gap: 6, zIndex: 1 }}
            >
              <svg width="12" height="12" viewBox="0 0 24 24" fill="#fff"><path d="M12 2C7.6 2 4 5.6 4 10c0 6 8 12 8 12s8-6 8-12c0-4.4-3.6-8-8-8zm0 11a3 3 0 1 1 0-6 3 3 0 0 1 0 6z" /></svg>
              {officeLocation ? officeLocation.address : "101 California St, Suite 2400"}
            </div>
            {isEditMode && (
              <div style={{ position: "absolute", top: 16, right: 16, zIndex: 2, display: "flex", gap: 8 }}>
                {officeLocation && (
                  <button
                    onClick={(e) => { e.stopPropagation(); deleteLocation(); }}
                    aria-label="Remove office location"
                    style={{ width: 30, height: 30, borderRadius: "50%", background: "rgba(255,255,255,0.92)", border: "none", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}
                  >
                    <TrashIcon color="#12161C" />
                  </button>
                )}
                <button
                  onClick={(e) => { e.stopPropagation(); openEditLocation(); }}
                  aria-label="Edit office location"
                  style={{ width: 30, height: 30, borderRadius: "50%", background: "rgba(255,255,255,0.92)", border: "none", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}
                >
                  <EditPencil color="#12161C" />
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
      )}

      {/* ── Social & Schedule Buttons (Always Visible) ── */}
      <div style={{ background: "#fff", margin: "0 16px 16px", borderRadius: 20, overflow: "hidden" }}>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 1, background: "#E4E8EE" }}>
          {[
            { label: "LinkedIn", href: cardsData.linkedinLink || "", icon: <path d="M4.98 3.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5zM3 9h4v12H3zM9 9h3.8v1.7h.05c.53-1 1.83-2 3.77-2 4 0 4.75 2.6 4.75 6.1V21H17v-5.4c0-1.3 0-3-1.8-3s-2.1 1.4-2.1 2.9V21H9z" /> },
            { label: "X", href: cardsData.twitterLink || "", icon: <path d="M18.9 2h3.3l-7.3 8.3L23.5 22h-6.8l-5.3-6.9L5.3 22H2l7.8-8.9L1.5 2h7l4.8 6.3zM17.7 20h1.8L7.4 4h-2z" /> },
            { label: "whatsApp", href: cardsData.whatsappNo ? `https://wa.me/${String(cardsData.whatsappNo).replace(/\D/g, "")}` : "", icon: <path d="M17.5 14.4c-.3-.1-1.7-.8-2-.9-.3-.1-.5-.1-.6.1-.2.3-.7.9-.9 1.1-.2.2-.3.2-.6.1-1.7-.9-2.9-1.6-4-3.5-.1-.2 0-.4.1-.5.2-.2.4-.5.6-.7.2-.2.2-.3.1-.6-.1-.3-.9-2-1.1-2.4-.2-.4-.4-.3-.6-.3-.2 0-.5 0-.7 0-.2 0-.6.1-.9.4-.3.4-1.2 1.1-1.2 2.7 0 1.6 1.2 3.2 1.3 3.4.1.2 1.9 3 4.7 4.1 2.3.9 2.8.7 3.3.7.5-.1 1.7-.7 2-1.4.3-.7.3-1.2.2-1.4-.1-.1-.3-.2-.6-.3zM12 2C6.5 2 2 6.5 2 12c0 1.9.5 3.7 1.5 5.2L2 22l4.9-1.3C8.4 21.5 10.1 22 12 22c5.5 0 10-4.5 10-10S17.5 2 12 2z" /> },
            { label: "Schedule", href: null, icon: <><rect x="3" y="5" width="18" height="16" rx="2" /><path d="M3 10h18M8 3v4M16 3v4" /></> },
          ].map((s, i) => (
            <button
              key={i}
              onClick={() => (s.label === "Schedule" ? setBookingVisible(true) : (s.href && window.open(s.href, "_blank")))}
              style={{ background: "#fff", border: "none", padding: "14px 4px", display: "flex", flexDirection: "column", alignItems: "center", gap: 5, fontSize: 11, fontWeight: 600, color: s.label !== "Schedule" && !s.href ? "#C7CDD6" : "#6B7480", cursor: s.label !== "Schedule" && !s.href ? "default" : "pointer" }}
            >
              <svg width="17" height="17" viewBox="0 0 24 24" fill={s.label === "Schedule" ? "none" : "currentColor"} stroke={s.label === "Schedule" ? "#1467E0" : "none"} strokeWidth="1.8" style={{ color: s.label === "Schedule" ? "#1467E0" : (s.href ? "#1467E0" : "#C7CDD6") }}>
                {s.icon}
              </svg>
              {s.label}
            </button>
          ))}
        </div>
      </div>

      {/* ── Footer Section: Why Use KC, Invite Friends, Download App ── */}
      {true && (
      <>
      {/* Flip Card now lives in the "My Digital Card" section above. */}

      {/* ── Bio (only when the About section isn't showing it) ── */}
      {cardsData.aiDescription && !(isEditMode || cardsData?.extendedProfile?.about) && (
        <div
          style={{
            margin: "10px 16px 0",
            padding: "12px 16px",
            background: "#EFF6FF",
            borderRadius: 12,
            border: "1px solid #0A66C2",
          }}
        >
          <p
            style={{
              fontSize: 13,
              color: "#555",
              lineHeight: 1.7,
              margin: 0,
            }}
          >
            {cardsData.aiDescription}
          </p>
        </div>
      )}

      {/* ── Why Use KC ── */}
      <div
        style={{
          margin: "24px 16px 0",
          background: "#FFFFFF",
          borderRadius: 12,
          padding: "20px 18px",
          border: "1px solid #E8E8E8",
          boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
          opacity: 1,
        }}
      >
        <h3
          style={{
            fontSize: 16,
            fontWeight: 700,
            color: "#1a1a1a",
            margin: "0 0 16px",
          }}
        >
          Why Use KC (Know Connections)!
        </h3>
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          {[
            "Effortless Contact Sharing & Organization",
            "Stay Connected with Your Network & Team",
            "Smart Contact Management for Business Growth",
            `Join ${cardsData.businessName || "KC"} Today & Simplify Networking!`,
          ].map((item, i) => (
            <div
              key={i}
              style={{ display: "flex", alignItems: "flex-start", gap: 10 }}
            >
              <span
                style={{
                  color: "#4CAF50",
                  fontWeight: 700,
                  fontSize: 16,
                  flexShrink: 0,
                  marginTop: 1,
                }}
              >
                ✓
              </span>
              <span style={{ fontSize: 14, color: "#333", lineHeight: 1.5 }}>
                {item}
              </span>
            </div>
          ))}
        </div>
      </div>

      {/* ── Invite / Let's Connect ── */}
      <div
        style={{
          margin: "24px 16px 0",
          background: "#FFFFFF",
          borderRadius: 12,
          padding: "20px 16px",
          opacity: 1,
          boxShadow: "0px 0px 0px 0.5px #00000008, 0px 5px 22px 0px #0000000A",
        }}
      >
        <p
          style={{
            fontFamily: "'Inter', sans-serif",
            fontSize: 14,
            fontWeight: 600,
            color: "#111927",
            lineHeight: "20px",
            letterSpacing: 0,
            margin: "0 0 16px",
          }}
        >
          Invite friends and family to KC (Know Connections) - seamless
          connections when you have everyone on KC (Know Connections)
        </p>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 8 }}>
          {/* Let's Connect button */}
          <button
            onClick={() => window.open("https://knowconnections.com/contact/", "_blank")}
            style={{
              height: 32,
              padding: "0 14px",
              background: "#375DFB",
              border: "none",
              borderRadius: 6,
              color: "#fff",
              fontWeight: 600,
              fontSize: 13,
              cursor: "pointer",
              flexShrink: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0px 0px 0px 1px #375DFB, 0px 1px 2px 0px #253EA77A",
              whiteSpace: "nowrap",
            }}
          >
            Let's Connect
          </button>
          <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
            {socialLinks.map((s, i) => (
              <a
                key={i}
                href={s.href || "#"}
                target="_blank"
                rel="noopener noreferrer"
                onClick={(e) => handleLinkClick(e, s.href)}
                style={{
                  width: 24,
                  height: 24,
                  borderRadius: "50%",
                  background: s.color,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#fff",
                  fontSize: 12.33,
                  textDecoration: "none",
                  flexShrink: 0,
                }}
              >
                {s.icon}
              </a>
            ))}
            <button
              onClick={() => {
                const url = window.location.href;
                if (navigator.share) {
                  navigator.share({ title: cardsData.businessName || "Digital Business Card", url }).catch(() => {
                    navigator.clipboard.writeText(url);
                    message.success("Link copied!");
                  });
                } else {
                  navigator.clipboard.writeText(url);
                  message.success("Link copied to clipboard!");
                }
              }}
              style={{
                width: 24,
                height: 24,
                borderRadius: "50%",
                background: "#2986D6",
                border: "none",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#fff",
                fontSize: 12.33,
                cursor: "pointer",
                flexShrink: 0,
              }}
            >
              <FaShare />
            </button>
          </div>
        </div>
      </div>

      {/* ── Download App ── */}
      <div style={{ padding: "24px 16px 40px", textAlign: "center" }}>
        <h2
          style={{
            fontFamily: "'Inter', sans-serif",
            fontSize: 24,
            fontWeight: 600,
            fontStyle: "normal",
            lineHeight: "100%",
            letterSpacing: 0,
            textTransform: "capitalize",
            color: "#191919",
            marginBottom: 16,
          }}
        >
          Download App
        </h2>
        <div
          style={{
            display: "flex",
            gap: 20,
            justifyContent: "center",
            width: 260,
            height: 40,
            margin: "0 auto",
            background: "#FFFFFF",
            borderRadius: 6,
          }}
        >
          <a
            href="https://play.google.com/store/apps/details?id=apps.knowconnections.com"
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "none" }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 7,
                width: 120,
                height: 40,
                padding: "0 10px",
                border: "1px solid #ddd",
                borderRadius: 6,
                background: "#fff",
                boxSizing: "border-box",
              }}
            >
              <GooglePlayIcon size={20} />
              <div style={{ textAlign: "left" }}>
                <div style={{ fontSize: 9, color: "#888", lineHeight: 1.2 }}>GET IT ON</div>
                <div style={{ fontSize: 12, fontWeight: 600, color: "#1a1a1a", lineHeight: 1.2 }}>
                  Google Play
                </div>
              </div>
            </div>
          </a>
          <a
            href="https://apps.apple.com/in/app/know-connections/id6741457754"
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "none" }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 7,
                width: 120,
                height: 40,
                padding: "0 10px",
                border: "1px solid #ddd",
                borderRadius: 6,
                background: "#fff",
                boxSizing: "border-box",
              }}
            >
              <FaApple style={{ fontSize: 18, color: "#333", flexShrink: 0 }} />
              <div style={{ textAlign: "left" }}>
                <div style={{ fontSize: 9, color: "#888", lineHeight: 1.2 }}>Download on the</div>
                <div style={{ fontSize: 12, fontWeight: 600, color: "#1a1a1a", lineHeight: 1.2 }}>
                  App Store
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>

      {/* ── Sticky Book Appointment Pill (disabled) ── */}
      {false && (
      <div
        style={{
          position: "fixed",
          bottom: 16,
          left: "50%",
          transform: "translateX(-50%)",
          zIndex: 100,
          pointerEvents: "none",
          width: "100%",
          maxWidth: 480,
          display: "flex",
          justifyContent: "center",
        }}
      >
        <button
          onClick={() => setBookingVisible(true)}
          style={{
            pointerEvents: "auto",
            display: "flex",
            alignItems: "center",
            gap: 10,
            background: "#fff",
            border: "none",
            borderRadius: 28,
            padding: "10px 22px 10px 10px",
            boxShadow: "0 4px 16px rgba(0,0,0,0.15)",
            cursor: "pointer",
            fontSize: 15,
            fontWeight: 600,
            color: "#1a1a1a",
          }}
        >
          <div style={{
            width: 36,
            height: 36,
            borderRadius: "50%",
            background: "#2986D6",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#fff",
            fontSize: 17,
            flexShrink: 0,
          }}>
            <FaRegCalendarAlt />
          </div>
          Book Appointment
        </button>
      </div>
      )}
      </>
      )}
      <BookAppointmentModal
        visible={bookingVisible}
        onClose={() => setBookingVisible(false)}
        userId={cardsData.userId}
        cardId={cardsData._id}
        cardOwnerName={cardsData.yourName || ''}
        businessName={cardsData.businessName || ''}
        cardImage={cardsData.image || ''}
      />

      {/* ── Share Your Contact Modal — 3-step wizard ── */}
      <Modal
        open={shareModalOpen}
        onCancel={closeShareModal}
        footer={null}
        closable={false}
        centered
        width={380}
        styles={{ body: { padding: 0 } }}
      >
        <div style={{ padding: "20px 20px 0" }}>
          <div style={{ fontSize: 12.5, fontWeight: 600, color: "#6B7480", marginBottom: 10 }}>
            Step {shareStep} of 2
          </div>
          <div style={{ height: 4, background: "#E9F1FE", borderRadius: 999, marginBottom: 16, overflow: "hidden" }}>
            <div style={{ height: "100%", width: `${(shareStep / 2) * 100}%`, background: "#1467E0", borderRadius: 999, transition: "width 0.25s" }} />
          </div>
          <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 18 }}>
            {["Basics", "Last Stretch"].map((label, i) => {
              const stepNum = i + 1;
              const done = shareStep > stepNum;
              const active = shareStep === stepNum;
              return (
                <div key={label} style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 4 }}>
                  <div
                    style={{
                      width: 22,
                      height: 22,
                      borderRadius: "50%",
                      background: done || active ? "#1467E0" : "#E4E8EE",
                      color: done || active ? "#fff" : "#9AA3AF",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: 11,
                      fontWeight: 700,
                      flexShrink: 0,
                    }}
                  >
                    {done ? "✓" : stepNum}
                  </div>
                  <span style={{ fontSize: 10.5, fontWeight: 600, color: active ? "#1467E0" : "#9AA3AF" }}>{label}</span>
                </div>
              );
            })}
          </div>
        </div>

        <div style={{ padding: "0 20px 20px" }}>
          {shareStep === 1 && (
            <>
              <div style={{ fontSize: 12.5, fontWeight: 700, color: "#1467E0", marginBottom: 4 }}>First up</div>
              <div style={{ fontSize: 17, fontWeight: 800, color: "#12161C", marginBottom: 16 }}>Who are we adding?</div>
              <div style={{ marginBottom: 14 }}>
                <div style={{ fontSize: 12.5, fontWeight: 600, color: "#6B7480", marginBottom: 6 }}>Full Name</div>
                <Input value={shareForm.fullName} onChange={(e) => setShareForm((p) => ({ ...p, fullName: e.target.value }))} placeholder="John Doe" size="large" />
              </div>
              <div style={{ marginBottom: 14 }}>
                <div style={{ fontSize: 12.5, fontWeight: 600, color: "#6B7480", marginBottom: 6 }}>Mobile Number</div>
                <Input value={shareForm.mobile} onChange={(e) => setShareForm((p) => ({ ...p, mobile: e.target.value }))} placeholder="+91 9999999999" size="large" />
              </div>
              <div style={{ marginBottom: 6 }}>
                <div style={{ fontSize: 12.5, fontWeight: 600, color: "#6B7480", marginBottom: 6 }}>WhatsApp Number</div>
                <Input value={shareForm.whatsapp} onChange={(e) => setShareForm((p) => ({ ...p, whatsapp: e.target.value }))} placeholder="+91 9999999999" size="large" />
              </div>
            </>
          )}
          {shareStep === 2 && (
            <>
              <div style={{ fontSize: 12.5, fontWeight: 700, color: "#1467E0", marginBottom: 4 }}>Last Stretch</div>
              <div style={{ fontSize: 17, fontWeight: 800, color: "#12161C", marginBottom: 16 }}>What's the story here?</div>
              <div style={{ marginBottom: 14 }}>
                <div style={{ fontSize: 12.5, fontWeight: 600, color: "#6B7480", marginBottom: 6 }}>How We Met?</div>
                <Input value={shareForm.howWeMet} onChange={(e) => setShareForm((p) => ({ ...p, howWeMet: e.target.value }))} placeholder="e.g Networking event" size="large" />
              </div>
              <div style={{ marginBottom: 14 }}>
                <div style={{ fontSize: 12.5, fontWeight: 600, color: "#6B7480", marginBottom: 6 }}>Business Category</div>
                <Input value={shareForm.businessCategory} onChange={(e) => setShareForm((p) => ({ ...p, businessCategory: e.target.value }))} placeholder="e.g Interior Design" size="large" />
              </div>
              <div style={{ marginBottom: 6 }}>
                <div style={{ fontSize: 12.5, fontWeight: 600, color: "#6B7480", marginBottom: 6 }}>Notes</div>
                <Input.TextArea
                  value={shareForm.notes}
                  onChange={(e) => setShareForm((p) => ({ ...p, notes: e.target.value }))}
                  placeholder="e.g. Looking to partner on ux design audit for upcoming mobile releases."
                  rows={3}
                />
              </div>
            </>
          )}
        </div>

        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "14px 20px", borderTop: "1px solid #EEF0F3" }}>
          {shareStep > 1 ? (
            <button onClick={goShareBack} style={{ background: "none", border: "none", cursor: "pointer", fontSize: 14, color: "#6B7480", fontWeight: 600, padding: 0 }}>
              Back
            </button>
          ) : <span />}
          {shareStep < 2 ? (
            <button
              onClick={goShareContinue}
              style={{ border: "none", background: "#1467E0", color: "#fff", fontWeight: 700, fontSize: 14, borderRadius: 10, padding: "11px 22px", cursor: "pointer" }}
            >
              Continue
            </button>
          ) : (
            <button
              onClick={submitShare}
              disabled={submittingShare}
              style={{ border: "none", background: "#1467E0", color: "#fff", fontWeight: 700, fontSize: 14, borderRadius: 10, padding: "11px 22px", cursor: "pointer" }}
            >
              {submittingShare ? "Sending..." : "Review & Send"}
            </button>
          )}
        </div>
      </Modal>

      {/* ── QR Code Popup ── */}
      <Modal
        open={qrModal.visible}
        onCancel={() => setQrModal({ visible: false, value: "" })}
        footer={null}
        centered
        width={260}
        title="Scan QR Code"
      >
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "16px 0 8px" }}>
          {qrModal.value && (
            <>
              <QRCode value={qrModal.value} size={180} />
              <a
                href={/^https?:\/\//i.test(qrModal.value) ? qrModal.value : `https://${qrModal.value}`}
                target="_blank"
                rel="noopener noreferrer"
                style={{ marginTop: 14, fontSize: 13, color: "#1467E0", textAlign: "center", wordBreak: "break-all" }}
              >
                {qrModal.value}
              </a>
            </>
          )}
        </div>
      </Modal>

      {/* ── Edit Intro Modal (edit mode only) ── */}
      <Modal
        open={editIntroModal}
        onCancel={() => setEditIntroModal(false)}
        footer={null}
        closable={false}
        centered
        width={380}
        styles={{ body: { padding: 0 } }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "16px 16px 12px",
            borderBottom: "1px solid #EEF0F3",
          }}
        >
          <button
            onClick={() => setEditIntroModal(false)}
            style={{ background: "none", border: "none", cursor: "pointer", fontSize: 14.5, color: "#6B7480", fontWeight: 600, padding: 0 }}
          >
            Cancel
          </button>
          <div style={{ fontSize: 15.5, fontWeight: 700, color: "#12161C" }}>Edit Intro</div>
          <button
            onClick={saveIntro}
            disabled={savingIntro || introUploadingPhoto}
            style={{ background: "none", border: "none", cursor: "pointer", fontSize: 14.5, color: "#1467E0", fontWeight: 700, padding: 0 }}
          >
            {savingIntro ? "Saving..." : introUploadingPhoto ? "Uploading..." : "Save"}
          </button>
        </div>

        <div style={{ padding: "20px 16px", maxHeight: "70vh", overflowY: "auto" }}>
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", marginBottom: 20 }}>
            <div style={{ position: "relative", width: 84, height: 84 }}>
              {introPhotoPreview ? (
                <img
                  src={introPhotoPreview}
                  alt="Profile"
                  style={{ width: 84, height: 84, borderRadius: "50%", objectFit: "contain", background: "#fff" }}
                />
              ) : (
                <div
                  style={{
                    width: 84,
                    height: 84,
                    borderRadius: "50%",
                    background: "linear-gradient(135deg,#2b3648,#4a5a72)",
                    color: "#fff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: 28,
                    fontWeight: 800,
                  }}
                >
                  {(introForm.yourName || "K").charAt(0).toUpperCase()}
                </div>
              )}
              <label
                htmlFor="introPhotoInput"
                style={{
                  position: "absolute",
                  bottom: 0,
                  right: 0,
                  width: 28,
                  height: 28,
                  borderRadius: "50%",
                  background: "#1467E0",
                  border: "2px solid #fff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                }}
              >
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2">
                  <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" />
                  <circle cx="12" cy="13" r="4" />
                </svg>
              </label>
              <input
                id="introPhotoInput"
                type="file"
                accept="image/*"
                onChange={handleIntroPhotoChange}
                style={{ display: "none" }}
              />
            </div>
            <label
              htmlFor="introPhotoInput"
              style={{ marginTop: 8, fontSize: 13, fontWeight: 600, color: "#1467E0", cursor: "pointer" }}
            >
              Change photo
            </label>
          </div>

          {[
            { key: "yourName", label: "Name", placeholder: "Your name" },
            { key: "designation", label: "Job Title", placeholder: "Job title" },
            { key: "businessName", label: "Company Name", placeholder: "Company name" },
            { key: "heading", label: "Heading / Tagline", placeholder: "e.g., Digital Innovator, Strategic Leader" },
          ].map((f) => (
            <div key={f.key} style={{ marginBottom: 14 }}>
              <div style={{ fontSize: 12.5, fontWeight: 600, color: "#6B7480", marginBottom: 6 }}>{f.label}</div>
              <Input
                value={introForm[f.key]}
                onChange={(e) => setIntroForm((p) => ({ ...p, [f.key]: e.target.value }))}
                placeholder={f.placeholder}
                size="large"
              />
            </div>
          ))}
        </div>
      </Modal>

      {/* ── Add/Edit Service Modal (edit mode only) ── */}
      <Modal
        open={serviceModal.open}
        onCancel={closeServiceModal}
        footer={null}
        closable={false}
        centered
        width={380}
        styles={{ body: { padding: 0 } }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "16px 16px 12px",
            borderBottom: "1px solid #EEF0F3",
          }}
        >
          <button
            onClick={closeServiceModal}
            style={{ background: "none", border: "none", cursor: "pointer", fontSize: 14.5, color: "#6B7480", fontWeight: 600, padding: 0 }}
          >
            Cancel
          </button>
          <div style={{ fontSize: 15.5, fontWeight: 700, color: "#12161C" }}>
            {serviceModal.mode === "edit" ? "Edit service" : "Add service"}
          </div>
          <button
            onClick={saveService}
            disabled={savingService}
            style={{ background: "none", border: "none", cursor: "pointer", fontSize: 14.5, color: "#1467E0", fontWeight: 700, padding: 0 }}
          >
            {savingService ? "Saving..." : "Save"}
          </button>
        </div>

        <div style={{ padding: "20px 16px", maxHeight: "70vh", overflowY: "auto" }}>
          <div style={{ marginBottom: 14 }}>
            <div style={{ fontSize: 12.5, fontWeight: 600, color: "#6B7480", marginBottom: 6 }}>Service Name</div>
            <Input
              value={serviceForm.title}
              onChange={(e) => setServiceForm((p) => ({ ...p, title: e.target.value }))}
              placeholder="Service Name"
              size="large"
            />
          </div>
          <div style={{ marginBottom: 14 }}>
            <div style={{ fontSize: 12.5, fontWeight: 600, color: "#6B7480", marginBottom: 6 }}>Badge category</div>
            <Input
              value={serviceForm.badge}
              onChange={(e) => setServiceForm((p) => ({ ...p, badge: e.target.value }))}
              placeholder="NFC Active"
              size="large"
            />
          </div>
          <div style={{ marginBottom: 14 }}>
            <div style={{ fontSize: 12.5, fontWeight: 600, color: "#6B7480", marginBottom: 6 }}>Description</div>
            <Input.TextArea
              value={serviceForm.desc}
              onChange={(e) => setServiceForm((p) => ({ ...p, desc: e.target.value }))}
              placeholder="Tap/ QR profile exchange with instant analytics & dynamic branding"
              rows={3}
            />
          </div>
          <div style={{ marginBottom: serviceModal.mode === "edit" ? 18 : 4 }}>
            <div style={{ fontSize: 12.5, fontWeight: 600, color: "#6B7480", marginBottom: 6 }}>Button Label</div>
            <Input
              value={serviceForm.cta}
              onChange={(e) => setServiceForm((p) => ({ ...p, cta: e.target.value }))}
              placeholder="Tap Card"
              size="large"
            />
          </div>
          {serviceModal.mode === "edit" && (
            <button
              onClick={deleteService}
              disabled={savingService}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 6,
                marginLeft: "auto",
                border: "none",
                background: "none",
                color: "#E5484D",
                fontWeight: 700,
                fontSize: 13,
                cursor: "pointer",
                padding: "6px 0",
              }}
            >
              <TrashIcon /> Delete Service
            </button>
          )}
        </div>
      </Modal>

      {/* ── Add/Edit Feature Modal (edit mode only) ── */}
      <Modal
        open={featureModal.open}
        onCancel={closeFeatureModal}
        footer={null}
        closable={false}
        centered
        width={380}
        styles={{ body: { padding: 0 } }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "16px 16px 12px",
            borderBottom: "1px solid #EEF0F3",
          }}
        >
          <button
            onClick={closeFeatureModal}
            style={{ background: "none", border: "none", cursor: "pointer", fontSize: 14.5, color: "#6B7480", fontWeight: 600, padding: 0 }}
          >
            Cancel
          </button>
          <div style={{ fontSize: 15.5, fontWeight: 700, color: "#12161C" }}>
            {featureModal.mode === "edit" ? "Edit Feature" : "Add Feature"}
          </div>
          <button
            onClick={saveFeature}
            disabled={savingFeature || featureUploadingPhoto}
            style={{ background: "none", border: "none", cursor: "pointer", fontSize: 14.5, color: "#1467E0", fontWeight: 700, padding: 0 }}
          >
            {savingFeature ? "Saving..." : featureUploadingPhoto ? "Uploading..." : "Save"}
          </button>
        </div>

        <div style={{ padding: "20px 16px", maxHeight: "70vh", overflowY: "auto" }}>
          <div
            style={{
              position: "relative",
              width: "100%",
              height: 150,
              borderRadius: 10,
              overflow: "hidden",
              marginBottom: 16,
              background: featurePhotoPreview ? "#0B1E45" : "linear-gradient(160deg, #14203A 0%, #1467E0 100%)",
            }}
          >
            {featurePhotoPreview && (
              <img src={featurePhotoPreview} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
            )}
            <label
              htmlFor="featurePhotoInput"
              style={{
                position: "absolute",
                bottom: 10,
                left: 10,
                width: 30,
                height: 30,
                borderRadius: "50%",
                background: "rgba(255,255,255,0.92)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
              }}
            >
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#12161C" strokeWidth="2">
                <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" />
                <circle cx="12" cy="13" r="4" />
              </svg>
            </label>
            <input
              id="featurePhotoInput"
              type="file"
              accept="image/*"
              onChange={handleFeaturePhotoChange}
              style={{ display: "none" }}
            />
          </div>

          <div style={{ marginBottom: 14 }}>
            <div style={{ fontSize: 12.5, fontWeight: 600, color: "#6B7480", marginBottom: 6 }}>Heading</div>
            <Input
              value={featureForm.heading}
              onChange={(e) => setFeatureForm((p) => ({ ...p, heading: e.target.value }))}
              placeholder="Global Keynote 2026"
              size="large"
            />
          </div>
          <div style={{ marginBottom: 6 }}>
            <div style={{ fontSize: 12.5, fontWeight: 600, color: "#6B7480", marginBottom: 6 }}>Sub Heading</div>
            <Input
              value={featureForm.subheading}
              onChange={(e) => setFeatureForm((p) => ({ ...p, subheading: e.target.value }))}
              placeholder="Enterprise Networking & NFC eco system"
              size="large"
            />
          </div>
          <p style={{ fontSize: 11.5, color: "#9AA3AF", margin: "4px 0 0" }}>
            *Suggestions: Customize stats relevant to your industry*
          </p>
        </div>
      </Modal>

      {/* ── Edit About Modal (edit mode only) ── */}
      <Modal
        open={aboutModalOpen}
        onCancel={() => setAboutModalOpen(false)}
        footer={null}
        closable={false}
        centered
        width={380}
        styles={{ body: { padding: 0 } }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "16px 16px 12px",
            borderBottom: "1px solid #EEF0F3",
          }}
        >
          <button
            onClick={() => setAboutModalOpen(false)}
            style={{ background: "none", border: "none", cursor: "pointer", fontSize: 14.5, color: "#6B7480", fontWeight: 600, padding: 0 }}
          >
            Cancel
          </button>
          <div style={{ fontSize: 15.5, fontWeight: 700, color: "#12161C" }}>Edit About</div>
          <button
            onClick={saveAbout}
            disabled={savingAbout}
            style={{ background: "none", border: "none", cursor: "pointer", fontSize: 14.5, color: "#1467E0", fontWeight: 700, padding: 0 }}
          >
            {savingAbout ? "Saving..." : "Save"}
          </button>
        </div>

        <div style={{ padding: "20px 16px" }}>
          <div style={{ fontSize: 12.5, fontWeight: 600, color: "#6B7480", marginBottom: 6 }}>About</div>
          <Input.TextArea
            value={aboutForm}
            onChange={(e) => setAboutForm(e.target.value)}
            placeholder="Tell visitors about yourself..."
            rows={8}
          />
        </div>
      </Modal>

      {/* ── Add/Edit Certification Modal (edit mode only) ── */}
      <Modal
        open={certModal.open}
        onCancel={closeCertModal}
        footer={null}
        closable={false}
        centered
        width={360}
        styles={{ body: { padding: 0 } }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "16px 16px 12px",
            borderBottom: "1px solid #EEF0F3",
          }}
        >
          <button
            onClick={closeCertModal}
            style={{ background: "none", border: "none", cursor: "pointer", fontSize: 14.5, color: "#6B7480", fontWeight: 600, padding: 0 }}
          >
            Cancel
          </button>
          <div style={{ fontSize: 15.5, fontWeight: 700, color: "#12161C" }}>
            {certModal.mode === "edit" ? "Edit Certification" : "Add Certification"}
          </div>
          <button
            onClick={saveCert}
            disabled={savingCert}
            style={{ background: "none", border: "none", cursor: "pointer", fontSize: 14.5, color: "#1467E0", fontWeight: 700, padding: 0 }}
          >
            {savingCert ? "Saving..." : "Save"}
          </button>
        </div>

        <div style={{ padding: "20px 16px" }}>
          <div style={{ fontSize: 12.5, fontWeight: 600, color: "#6B7480", marginBottom: 6 }}>Certification / Badge Name</div>
          <Input
            value={certForm}
            onChange={(e) => setCertForm(e.target.value)}
            placeholder="ISO 27001 Certified"
            size="large"
          />
        </div>
      </Modal>

      {/* ── Add/Edit Testimonial Modal (edit mode only) ── */}
      <Modal
        open={testimonialModal.open}
        onCancel={closeTestimonialModal}
        footer={null}
        closable={false}
        centered
        width={380}
        styles={{ body: { padding: 0 } }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "16px 16px 12px",
            borderBottom: "1px solid #EEF0F3",
          }}
        >
          <button
            onClick={closeTestimonialModal}
            style={{ background: "none", border: "none", cursor: "pointer", fontSize: 14.5, color: "#6B7480", fontWeight: 600, padding: 0 }}
          >
            Cancel
          </button>
          <div style={{ fontSize: 15.5, fontWeight: 700, color: "#12161C" }}>
            {testimonialModal.mode === "edit" ? "Edit Testimonial" : "Add Testimonial"}
          </div>
          <button
            onClick={saveTestimonial}
            disabled={savingTestimonial || testimonialUploadingPhoto}
            style={{ background: "none", border: "none", cursor: "pointer", fontSize: 14.5, color: "#1467E0", fontWeight: 700, padding: 0 }}
          >
            {savingTestimonial ? "Saving..." : testimonialUploadingPhoto ? "Uploading..." : "Save"}
          </button>
        </div>

        <div style={{ padding: "20px 16px", maxHeight: "70vh", overflowY: "auto" }}>
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", marginBottom: 20 }}>
            <div style={{ position: "relative", width: 76, height: 76 }}>
              {testimonialPhotoPreview ? (
                <img
                  src={testimonialPhotoPreview}
                  alt="Author"
                  style={{ width: 76, height: 76, borderRadius: "50%", objectFit: "cover" }}
                />
              ) : (
                <div
                  style={{
                    width: 76,
                    height: 76,
                    borderRadius: "50%",
                    background: "linear-gradient(135deg,#e2996b,#c96a4e)",
                    color: "#fff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: 24,
                    fontWeight: 800,
                  }}
                >
                  {getInitials(testimonialForm.name)}
                </div>
              )}
              <label
                htmlFor="testimonialPhotoInput"
                style={{
                  position: "absolute",
                  bottom: 0,
                  right: 0,
                  width: 26,
                  height: 26,
                  borderRadius: "50%",
                  background: "#1467E0",
                  border: "2px solid #fff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                }}
              >
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2">
                  <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" />
                  <circle cx="12" cy="13" r="4" />
                </svg>
              </label>
              <input
                id="testimonialPhotoInput"
                type="file"
                accept="image/*"
                onChange={handleTestimonialPhotoChange}
                style={{ display: "none" }}
              />
            </div>
            <label
              htmlFor="testimonialPhotoInput"
              style={{ marginTop: 8, fontSize: 13, fontWeight: 600, color: "#1467E0", cursor: "pointer" }}
            >
              Change photo
            </label>
          </div>

          <div style={{ marginBottom: 14 }}>
            <div style={{ fontSize: 12.5, fontWeight: 600, color: "#6B7480", marginBottom: 6 }}>Author Name</div>
            <Input
              value={testimonialForm.name}
              onChange={(e) => setTestimonialForm((p) => ({ ...p, name: e.target.value }))}
              placeholder="Shivanshu Dubey"
              size="large"
            />
          </div>
          <div style={{ marginBottom: 14 }}>
            <div style={{ fontSize: 12.5, fontWeight: 600, color: "#6B7480", marginBottom: 6 }}>Title &amp; Company</div>
            <Input
              value={testimonialForm.role}
              onChange={(e) => setTestimonialForm((p) => ({ ...p, role: e.target.value }))}
              placeholder="Teacher"
              size="large"
            />
          </div>
          <div style={{ marginBottom: 14 }}>
            <div style={{ fontSize: 12.5, fontWeight: 600, color: "#6B7480", marginBottom: 6 }}>Rating</div>
            <div style={{ display: "flex", alignItems: "center", gap: 6, border: "1px solid #d9d9d9", borderRadius: 8, padding: "9px 12px" }}>
              {[1, 2, 3, 4, 5].map((n) => (
                <span
                  key={n}
                  onClick={() => setTestimonialForm((p) => ({ ...p, rating: n }))}
                  style={{ cursor: "pointer", fontSize: 18, lineHeight: 1, color: n <= testimonialForm.rating ? "#F5A524" : "#D9D9D9" }}
                >
                  ★
                </span>
              ))}
              <span style={{ fontSize: 12.5, color: "#6B7480", marginLeft: 4 }}>{testimonialForm.rating.toFixed(1)} Stars</span>
            </div>
          </div>
          <div style={{ marginBottom: 6 }}>
            <div style={{ fontSize: 12.5, fontWeight: 600, color: "#6B7480", marginBottom: 6 }}>Recommendation / Review</div>
            <Input.TextArea
              value={testimonialForm.quote}
              onChange={(e) => setTestimonialForm((p) => ({ ...p, quote: e.target.value }))}
              placeholder="Know Connections completely transformed how I network..."
              rows={4}
            />
          </div>
        </div>
      </Modal>

      {/* ── Add/Edit Contact Modal (edit mode only) ── */}
      <Modal
        open={contactModal.open}
        onCancel={closeContactModal}
        footer={null}
        closable={false}
        centered
        width={360}
        styles={{ body: { padding: 0 } }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "16px 16px 12px",
            borderBottom: "1px solid #EEF0F3",
          }}
        >
          <button
            onClick={closeContactModal}
            style={{ background: "none", border: "none", cursor: "pointer", fontSize: 14.5, color: "#6B7480", fontWeight: 600, padding: 0 }}
          >
            Cancel
          </button>
          <div style={{ fontSize: 15.5, fontWeight: 700, color: "#12161C" }}>
            {contactModal.mode === "edit" ? "Edit Contact" : "Add Contact"}
          </div>
          <button
            onClick={saveContact}
            disabled={savingContact || contactUploadingLogo}
            style={{ background: "none", border: "none", cursor: "pointer", fontSize: 14.5, color: "#1467E0", fontWeight: 700, padding: 0 }}
          >
            {savingContact ? "Saving..." : contactUploadingLogo ? "Uploading..." : "Save"}
          </button>
        </div>

        <div style={{ padding: "20px 16px" }}>
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", marginBottom: 20 }}>
            <div style={{ position: "relative", width: 60, height: 60 }}>
              <div
                style={{
                  width: 60,
                  height: 60,
                  borderRadius: 14,
                  background: "#E9F1FE",
                  color: "#1467E0",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  overflow: "hidden",
                }}
              >
                {contactIconPreview ? (
                  <img src={contactIconPreview} alt="Logo" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                ) : (
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    {renderContactIconPaths(contactModal.mode === "edit" ? contacts[contactModal.index]?.iconType : "custom")}
                  </svg>
                )}
              </div>
              <label
                htmlFor="contactIconInput"
                style={{
                  position: "absolute",
                  bottom: -4,
                  right: -4,
                  width: 24,
                  height: 24,
                  borderRadius: "50%",
                  background: "#1467E0",
                  border: "2px solid #fff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                }}
              >
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2">
                  <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" />
                  <circle cx="12" cy="13" r="4" />
                </svg>
              </label>
              <input
                id="contactIconInput"
                type="file"
                accept="image/*"
                onChange={handleContactIconChange}
                style={{ display: "none" }}
              />
            </div>
            <label
              htmlFor="contactIconInput"
              style={{ marginTop: 8, fontSize: 13, fontWeight: 600, color: "#1467E0", cursor: "pointer" }}
            >
              Change logo
            </label>
          </div>

          <div style={{ marginBottom: 14 }}>
            <div style={{ fontSize: 12.5, fontWeight: 600, color: "#6B7480", marginBottom: 6 }}>Contact Name</div>
            <Input
              value={contactForm.label}
              onChange={(e) => setContactForm((p) => ({ ...p, label: e.target.value }))}
              placeholder="e.g. Executive Line"
              size="large"
            />
          </div>
          <div style={{ marginBottom: 6 }}>
            <div style={{ fontSize: 12.5, fontWeight: 600, color: "#6B7480", marginBottom: 6 }}>Contact Info</div>
            <Input
              value={contactForm.value}
              onChange={(e) => setContactForm((p) => ({ ...p, value: e.target.value }))}
              placeholder="Phone number, email, or link"
              size="large"
            />
          </div>
        </div>
      </Modal>

      {/* ── Edit Office Location Modal (edit mode only) ── */}
      <Modal
        open={locationModalOpen}
        onCancel={closeLocationModal}
        footer={null}
        closable={false}
        centered
        width={380}
        destroyOnClose
        styles={{ body: { padding: 0 } }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "16px 16px 12px",
            borderBottom: "1px solid #EEF0F3",
          }}
        >
          <button
            onClick={closeLocationModal}
            style={{ background: "none", border: "none", cursor: "pointer", fontSize: 14.5, color: "#6B7480", fontWeight: 600, padding: 0 }}
          >
            Cancel
          </button>
          <div style={{ fontSize: 15.5, fontWeight: 700, color: "#12161C" }}>Edit Office Location</div>
          <button
            onClick={saveLocation}
            disabled={savingLocation || locationForm.lat == null}
            style={{ background: "none", border: "none", cursor: locationForm.lat == null ? "not-allowed" : "pointer", fontSize: 14.5, color: locationForm.lat == null ? "#B7C2D0" : "#1467E0", fontWeight: 700, padding: 0 }}
          >
            {savingLocation ? "Saving..." : "Save"}
          </button>
        </div>

        <div style={{ padding: "20px 16px" }}>
          <div style={{ fontSize: 12.5, fontWeight: 600, color: "#6B7480", marginBottom: 6 }}>Address</div>
          <input
            ref={locationInputRef}
            defaultValue={locationForm.address}
            placeholder="Search for an address..."
            style={{ width: "100%", boxSizing: "border-box", border: "1px solid #d9d9d9", borderRadius: 8, padding: "10px 12px", fontSize: 14, outline: "none" }}
          />
          {!mapsReady && (
            <p style={{ fontSize: 11.5, color: "#9AA3AF", margin: "8px 0 0" }}>Loading address search…</p>
          )}
          {locationForm.lat != null && (
            <img
              src={staticMapUrl(locationForm.lat, locationForm.lng, 340, 150)}
              alt="Selected location preview"
              style={{ width: "100%", height: 150, borderRadius: 10, marginTop: 14, objectFit: "cover" }}
            />
          )}
          <p style={{ fontSize: 11.5, color: "#9AA3AF", margin: "10px 0 0" }}>
            *Pick a suggestion from the list to set the exact location and map preview
          </p>
        </div>
      </Modal>

      {/* ── Add/Edit Stat Modal (edit mode only) ── */}
      <Modal
        open={statsModal.open}
        onCancel={closeStatsModal}
        footer={null}
        closable={false}
        centered
        width={360}
        styles={{ body: { padding: 0 } }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "16px 16px 12px",
            borderBottom: "1px solid #EEF0F3",
          }}
        >
          <button
            onClick={closeStatsModal}
            style={{ background: "none", border: "none", cursor: "pointer", fontSize: 14.5, color: "#6B7480", fontWeight: 600, padding: 0 }}
          >
            Cancel
          </button>
          <div style={{ fontSize: 15.5, fontWeight: 700, color: "#12161C" }}>
            {statsModal.mode === "edit" ? "Edit Stat" : "Add Stat"}
          </div>
          <button
            onClick={saveStat}
            disabled={savingStats}
            style={{ background: "none", border: "none", cursor: "pointer", fontSize: 14.5, color: "#1467E0", fontWeight: 700, padding: 0 }}
          >
            {savingStats ? "Saving..." : "Save"}
          </button>
        </div>

        <div style={{ padding: "20px 16px" }}>
          <div style={{ marginBottom: 14 }}>
            <div style={{ fontSize: 12.5, fontWeight: 600, color: "#6B7480", marginBottom: 6 }}>Label</div>
            <Input
              value={statsForm.label}
              onChange={(e) => setStatsForm((p) => ({ ...p, label: e.target.value }))}
              placeholder="e.g. Years Exp, Total Deals"
              size="large"
            />
          </div>
          <div style={{ marginBottom: 14 }}>
            <div style={{ fontSize: 12.5, fontWeight: 600, color: "#6B7480", marginBottom: 6 }}>Value</div>
            <Input
              value={statsForm.value}
              onChange={(e) => setStatsForm((p) => ({ ...p, value: e.target.value }))}
              placeholder="e.g. 15+, 500+, 98%"
              size="large"
            />
          </div>
          <div style={{ marginBottom: 6 }}>
            <label style={{ display: "flex", alignItems: "center", gap: 8, cursor: "pointer", fontSize: 13, fontWeight: 600, color: "#12161C" }}>
              <input
                type="checkbox"
                checked={statsForm.green || false}
                onChange={(e) => setStatsForm((p) => ({ ...p, green: e.target.checked }))}
                style={{ cursor: "pointer" }}
              />
              Highlight in green (e.g., for success metrics)
            </label>
          </div>
          {statsModal.mode === "edit" && (
            <button
              onClick={() => deleteStat(statsModal.index)}
              disabled={savingStats}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 6,
                marginTop: 18,
                marginLeft: "auto",
                border: "none",
                background: "none",
                color: "#E5484D",
                fontWeight: 700,
                fontSize: 13,
                cursor: "pointer",
                padding: "6px 0",
              }}
            >
              <TrashIcon /> Delete Stat
            </button>
          )}
        </div>
      </Modal>

      {/* ── Add/Edit Product Modal (edit mode only) ── */}
      <Modal
        open={productModal.open}
        onCancel={closeProductModal}
        footer={null}
        closable={false}
        centered
        width={380}
        styles={{ body: { padding: 0 } }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "16px 16px 12px",
            borderBottom: "1px solid #EEF0F3",
          }}
        >
          <button
            onClick={closeProductModal}
            style={{ background: "none", border: "none", cursor: "pointer", fontSize: 14.5, color: "#6B7480", fontWeight: 600, padding: 0 }}
          >
            Cancel
          </button>
          <div style={{ fontSize: 15.5, fontWeight: 700, color: "#12161C" }}>
            {productModal.mode === "edit" ? "Edit Product" : "Add Product"}
          </div>
          <button
            onClick={saveProduct}
            disabled={savingProduct}
            style={{ background: "none", border: "none", cursor: "pointer", fontSize: 14.5, color: "#1467E0", fontWeight: 700, padding: 0 }}
          >
            {savingProduct ? "Saving..." : "Save"}
          </button>
        </div>

        <div style={{ padding: "20px 16px", maxHeight: "70vh", overflowY: "auto" }}>
          <div style={{ marginBottom: 14 }}>
            <div style={{ fontSize: 12.5, fontWeight: 600, color: "#6B7480", marginBottom: 6 }}>Product Name</div>
            <Input
              value={productForm.name}
              onChange={(e) => setProductForm((p) => ({ ...p, name: e.target.value }))}
              placeholder="e.g. Digital Business Card"
              size="large"
            />
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "2fr 1fr", gap: 12, marginBottom: 14 }}>
            <div>
              <div style={{ fontSize: 12.5, fontWeight: 600, color: "#6B7480", marginBottom: 6 }}>Price</div>
              <Input
                value={productForm.price}
                onChange={(e) => setProductForm((p) => ({ ...p, price: e.target.value }))}
                placeholder="e.g. 2500"
                size="large"
              />
            </div>
            <div>
              <div style={{ fontSize: 12.5, fontWeight: 600, color: "#6B7480", marginBottom: 6 }}>Currency</div>
              <select
                value={productForm.currency}
                onChange={(e) => setProductForm((p) => ({ ...p, currency: e.target.value }))}
                style={{ width: "100%", padding: "8px 12px", border: "1px solid #d9d9d9", borderRadius: 6, fontSize: 14 }}
              >
                <option value="INR">₹ INR</option>
                <option value="USD">$ USD</option>
                <option value="EUR">€ EUR</option>
                <option value="GBP">£ GBP</option>
              </select>
            </div>
          </div>
          <div style={{ marginBottom: 14 }}>
            <div style={{ fontSize: 12.5, fontWeight: 600, color: "#6B7480", marginBottom: 6 }}>Type</div>
            <select
              value={productForm.type}
              onChange={(e) => setProductForm((p) => ({ ...p, type: e.target.value }))}
              style={{ width: "100%", padding: "8px 12px", border: "1px solid #d9d9d9", borderRadius: 6, fontSize: 14 }}
            >
              <option value="product">Product</option>
              <option value="service">Service</option>
            </select>
          </div>
          <div style={{ marginBottom: 14 }}>
            <div style={{ fontSize: 12.5, fontWeight: 600, color: "#6B7480", marginBottom: 6 }}>Product Image</div>
            <div style={{ position: "relative", width: "100%", height: 120, borderRadius: 10, overflow: "hidden", marginBottom: 10, background: "#f5f5f5", display: "flex", alignItems: "center", justifyContent: "center" }}>
              {productPhotoPreview ? (
                <img src={productPhotoPreview} alt="Product" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
              ) : (
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#999" strokeWidth="2">
                  <rect x="3" y="3" width="18" height="18" rx="2" />
                  <circle cx="8.5" cy="8.5" r="1.5" />
                  <path d="M21 15l-5-5L5 21" />
                </svg>
              )}
              <label
                htmlFor="productImageInput"
                style={{
                  position: "absolute",
                  bottom: 8,
                  right: 8,
                  width: 32,
                  height: 32,
                  borderRadius: "50%",
                  background: "#1467E0",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  border: "2px solid #fff",
                }}
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2">
                  <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" />
                  <circle cx="12" cy="13" r="4" />
                </svg>
              </label>
              <input
                id="productImageInput"
                type="file"
                accept="image/*"
                onChange={handleProductPhotoChange}
                disabled={productUploadingPhoto}
                style={{ display: "none" }}
              />
            </div>
            {productUploadingPhoto && <p style={{ fontSize: 12, color: "#999", margin: 0 }}>Uploading image...</p>}
          </div>
          <div style={{ marginBottom: 6 }}>
            <div style={{ fontSize: 12.5, fontWeight: 600, color: "#6B7480", marginBottom: 6 }}>Description</div>
            <Input.TextArea
              value={productForm.description}
              onChange={(e) => setProductForm((p) => ({ ...p, description: e.target.value }))}
              placeholder="Describe your product..."
              rows={4}
            />
          </div>
          {productModal.mode === "edit" && (
            <button
              onClick={() => deleteProduct(productModal.index)}
              disabled={savingProduct}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 6,
                marginTop: 18,
                marginLeft: "auto",
                border: "none",
                background: "none",
                color: "#E5484D",
                fontWeight: 700,
                fontSize: 13,
                cursor: "pointer",
                padding: "6px 0",
              }}
            >
              <TrashIcon /> Delete Product
            </button>
          )}
        </div>
      </Modal>

      {/* ── Add YouTube Video Modal (edit mode only) ── */}
      <Modal
        open={videoGalleryModal}
        onCancel={() => setVideoGalleryModal(false)}
        footer={null}
        closable={false}
        centered
        width={380}
        styles={{ body: { padding: 0 } }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "16px 16px 12px",
            borderBottom: "1px solid #EEF0F3",
          }}
        >
          <button
            onClick={() => setVideoGalleryModal(false)}
            style={{ background: "none", border: "none", cursor: "pointer", fontSize: 14.5, color: "#6B7480", fontWeight: 600, padding: 0 }}
          >
            Cancel
          </button>
          <div style={{ fontSize: 15.5, fontWeight: 700, color: "#12161C" }}>Add Video</div>
          <button
            onClick={saveVideo}
            disabled={savingVideo}
            style={{ background: "none", border: "none", cursor: "pointer", fontSize: 14.5, color: "#1467E0", fontWeight: 700, padding: 0 }}
          >
            {savingVideo ? "Saving..." : "Add"}
          </button>
        </div>

        <div style={{ padding: "20px 16px" }}>
          <div style={{ marginBottom: 6 }}>
            <div style={{ fontSize: 12.5, fontWeight: 600, color: "#6B7480", marginBottom: 6 }}>YouTube Video URL</div>
            <Input
              value={videoForm.youtubeUrl}
              onChange={(e) => setVideoForm({ youtubeUrl: e.target.value })}
              placeholder="e.g. https://www.youtube.com/watch?v=dQw4w9WgXcQ"
              size="large"
            />
            <p style={{ fontSize: 11.5, color: "#9AA3AF", margin: "8px 0 0" }}>
              Paste the YouTube video URL. Thumbnail will be auto-generated.
            </p>
          </div>
        </div>
      </Modal>

      {/* ── Upload PDF Brochure Modal (edit mode only) ── */}
      <Modal
        open={pdfModalOpen}
        onCancel={() => setPdfModalOpen(false)}
        footer={null}
        closable={false}
        centered
        width={380}
        styles={{ body: { padding: 0 } }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "16px 16px 12px",
            borderBottom: "1px solid #EEF0F3",
          }}
        >
          <button
            onClick={() => setPdfModalOpen(false)}
            style={{ background: "none", border: "none", cursor: "pointer", fontSize: 14.5, color: "#6B7480", fontWeight: 600, padding: 0 }}
          >
            Cancel
          </button>
          <div style={{ fontSize: 15.5, fontWeight: 700, color: "#12161C" }}>Upload Brochure</div>
          <button
            onClick={savePdf}
            disabled={savingPdf || !pdfFile}
            style={{ background: "none", border: "none", cursor: "pointer", fontSize: 14.5, color: pdfFile ? "#1467E0" : "#B7C2D0", fontWeight: 700, padding: 0 }}
          >
            {savingPdf ? "Saving..." : "Save"}
          </button>
        </div>

        <div style={{ padding: "20px 16px" }}>
          <div style={{ marginBottom: 14 }}>
            <div style={{ fontSize: 12.5, fontWeight: 600, color: "#6B7480", marginBottom: 6 }}>PDF File (Max 50 MB)</div>
            <label
              htmlFor="pdfFileInput"
              style={{
                display: "block",
                padding: "20px",
                border: "2px dashed #d9d9d9",
                borderRadius: 8,
                textAlign: "center",
                cursor: "pointer",
                backgroundColor: "#fafafa",
                transition: "all 0.3s",
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.borderColor = "#1467E0";
                e.currentTarget.style.backgroundColor = "#f0f5ff";
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.borderColor = "#d9d9d9";
                e.currentTarget.style.backgroundColor = "#fafafa";
              }}
            >
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#1467E0" strokeWidth="2" style={{ margin: "0 auto 8px", display: "block" }}>
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                <polyline points="14 2 14 8 20 8" />
                <path d="M12 11v6" />
                <path d="M9 14h6" />
              </svg>
              <p style={{ fontSize: 13, fontWeight: 600, color: "#12161C", margin: "0 0 4px" }}>Click to upload or drag and drop</p>
              <p style={{ fontSize: 11, color: "#9AA3AF", margin: 0 }}>PDF (up to 50 MB)</p>
            </label>
            <input
              id="pdfFileInput"
              type="file"
              accept=".pdf"
              onChange={handlePdfFileChange}
              disabled={pdfUploadingFile}
              style={{ display: "none" }}
            />
            {pdfUploadingFile && <p style={{ fontSize: 12, color: "#999", margin: "8px 0 0", textAlign: "center" }}>Uploading...</p>}
            {pdfFile && <p style={{ fontSize: 12, color: "#1E9E5A", margin: "8px 0 0", textAlign: "center" }}>✓ {pdfFile.name}</p>}
          </div>
        </div>
      </Modal>

      {/* ── Send Inquiry Modal (About section's "Inquiries" button) ── */}
      <Modal
        open={inquiryModalOpen}
        onCancel={() => setInquiryModalOpen(false)}
        footer={null}
        closable={false}
        centered
        width={360}
        styles={{ body: { padding: 0 } }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "16px 16px 12px",
            borderBottom: "1px solid #EEF0F3",
          }}
        >
          <button
            onClick={() => setInquiryModalOpen(false)}
            style={{ background: "none", border: "none", cursor: "pointer", fontSize: 14.5, color: "#6B7480", fontWeight: 600, padding: 0 }}
          >
            Cancel
          </button>
          <div style={{ fontSize: 15.5, fontWeight: 700, color: "#12161C" }}>Send Inquiry</div>
          <button
            onClick={submitInquiry}
            disabled={submittingInquiry}
            style={{ background: "none", border: "none", cursor: "pointer", fontSize: 14.5, color: "#2A84FF", fontWeight: 700, padding: 0 }}
          >
            {submittingInquiry ? "Sending..." : "Send"}
          </button>
        </div>

        <div style={{ padding: "20px 16px" }}>
          <div style={{ marginBottom: 14 }}>
            <div style={{ fontSize: 12.5, fontWeight: 600, color: "#6B7480", marginBottom: 6 }}>Name</div>
            <Input
              value={inquiryForm.name}
              onChange={(e) => setInquiryForm((p) => ({ ...p, name: e.target.value }))}
              placeholder="Your name"
              size="large"
            />
          </div>
          <div style={{ marginBottom: 14 }}>
            <div style={{ fontSize: 12.5, fontWeight: 600, color: "#6B7480", marginBottom: 6 }}>Phone Number</div>
            <Input
              value={inquiryForm.phone}
              onChange={(e) => setInquiryForm((p) => ({ ...p, phone: e.target.value }))}
              placeholder="Your phone number"
              size="large"
            />
          </div>
          <div style={{ marginBottom: 14 }}>
            <div style={{ fontSize: 12.5, fontWeight: 600, color: "#6B7480", marginBottom: 6 }}>Email</div>
            <Input
              value={inquiryForm.email}
              onChange={(e) => setInquiryForm((p) => ({ ...p, email: e.target.value }))}
              placeholder="you@example.com"
              size="large"
            />
          </div>
          <div style={{ marginBottom: 6 }}>
            <div style={{ fontSize: 12.5, fontWeight: 600, color: "#6B7480", marginBottom: 6 }}>Message</div>
            <Input.TextArea
              value={inquiryForm.message}
              onChange={(e) => setInquiryForm((p) => ({ ...p, message: e.target.value }))}
              placeholder="Tell us about your inquiry..."
              rows={4}
            />
          </div>
        </div>
      </Modal>

      {/* ── Shared delete-confirm popup (replaces window.confirm everywhere) ── */}
      <Modal
        open={confirmModal.open}
        onCancel={closeConfirm}
        footer={null}
        closable={false}
        centered
        width={320}
        styles={{ body: { padding: 0 } }}
      >
        <div style={{ padding: "28px 20px 20px", textAlign: "center" }}>
          <div
            style={{
              width: 52,
              height: 52,
              borderRadius: "50%",
              background: "#E9F1FE",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 16px",
            }}
          >
            <TrashIcon size={22} color="#1467E0" />
          </div>
          <div style={{ fontSize: 15.5, fontWeight: 700, color: "#12161C", marginBottom: 6 }}>
            {confirmModal.message || "Delete this item?"}
          </div>
          <p style={{ fontSize: 12.5, color: "#6B7480", margin: "0 0 20px" }}>This action can't be undone.</p>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
            <button
              onClick={closeConfirm}
              style={{ border: "1.5px solid #E4E8EE", background: "#fff", color: "#12161C", fontWeight: 700, fontSize: 14, borderRadius: 10, padding: "11px 0", cursor: "pointer" }}
            >
              Cancel
            </button>
            <button
              onClick={handleConfirmYes}
              style={{ border: "none", background: "#1467E0", color: "#fff", fontWeight: 700, fontSize: 14, borderRadius: 10, padding: "11px 0", cursor: "pointer" }}
            >
              Delete
            </button>
          </div>
        </div>
      </Modal>

      {/* OTP Modal for Edit Link */}
      <EditOtpModal
        cardId={id}
        open={showEditOtpModal}
        onSuccess={handleEditOtpSuccess}
        onCancel={handleEditOtpCancel}
      />

      {/* Card Modal */}
      {cardModalOpen && (
        <div className="card-modal-overlay" onClick={() => { setCardModalOpen(false); setCardModalFlipped(false); }}>
          <div className="card-modal-container" onClick={(e) => e.stopPropagation()}>
            <button
              className="card-modal-close-btn"
              onClick={() => { setCardModalOpen(false); setCardModalFlipped(false); }}
              aria-label="Close card modal"
            >
              ✕
            </button>
            <div className="card-modal-content">
              <div
                className="flip-container"
                onClick={() => setCardModalFlipped(!cardModalFlipped)}
                style={{ width: "100%", position: "relative", cursor: "pointer" }}
              >
                <div className={`flipper ${cardModalFlipped ? "flipped" : ""}`}>
                  <ThemeComponent
                    cardsData={cardsData}
                    defaultimage={defaultimage}
                    onQrClick={(val) => setQrModal({ visible: true, value: val })}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProfileCard;
